import React from 'react';

var sizeMap = {
  small: 16,
  medium: 24,
  large: 32,
  fixed: "1em"
};

function getSvgProps(_ref) {
  var name = _ref.name,
      ariaLabel = _ref["aria-label"],
      size = _ref.size,
      svgDataByHeight = _ref.svgDataByHeight;

  var height = sizeMap[size] || parseInt(size) || 0;
  var naturalHeight = closestNaturalHeight(Object.keys(svgDataByHeight), height);
  var naturalWidth = svgDataByHeight[naturalHeight].width;
  var width = Number.isInteger(height) ? height * (naturalWidth / naturalHeight) : height;
  var path = svgDataByHeight[naturalHeight].path;

  return {
    "aria-hidden": "true",
    "aria-label": ariaLabel || name,
    role: "img",
    viewBox: "0 0 " + naturalWidth + " " + naturalHeight,
    width: width,
    height: height,
    fill: "currentColor",
    style: {
      display: "inline-block",
      userSelect: "none",
      verticalAlign: "middle"
    },
    dangerouslySetInnerHTML: { __html: path }
  };
}

function closestNaturalHeight(naturalHeights, height) {
  return naturalHeights.map(function (naturalHeight) {
    return parseInt(naturalHeight, 10);
  }).reduce(function (acc, naturalHeight) {
    return naturalHeight <= height ? naturalHeight : acc;
  }, naturalHeights[0]);
}

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function AccordionIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M14.75 5.9V3.49L11 2.5 9.44 3 8 2.51 6.57 3 5 2.5l-2.82.75a1.24 1.24 0 00-.93 1.2V5.9A1.25 1.25 0 000 7.15v1.5A1.25 1.25 0 001.25 9.9v1.65a1.24 1.24 0 00.93 1.2L5 13.5l1.57-.45 1.43.44 1.43-.44 1.57.45 3.75-1V9.9A1.25 1.25 0 0016 8.65v-1.5a1.25 1.25 0 00-1.25-1.25zm-11 6l-1.25-.35v-7.1l1.25-.33zm1.25.3V3.8l1 .27v7.86zm2.21-.26V4.06L8 3.82l.79.24v7.88l-.79.24zm2.84 0V4.07L11 3.8v8.4zm3.45-.38l-1.25.33V4.12l1.25.33z\"></path>" } };
  var name = 'Accordion';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

AccordionIcon.defaultProps = {
  size: 'small'
};

function AlignCenterIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M3.13 9h9.75v1.25H3.13zM.5 5.75h15V7H.5zm0 6.5h15v1.25H.5zM3.13 2.5h9.75v1.25H3.13z\"></path>" } };
  var name = 'AlignCenter';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

AlignCenterIcon.defaultProps = {
  size: 'small'
};

function AlignLeftIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M.5 9h9.75v1.25H.5zm0-3.25h15V7H.5zm0 6.5h15v1.25H.5zm0-9.75h9.75v1.25H.5z\"></path>" } };
  var name = 'AlignLeft';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

AlignLeftIcon.defaultProps = {
  size: 'small'
};

function AlignRightIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M5.75 9h9.75v1.25H5.75zM.5 5.75h15V7H.5zm0 6.5h15v1.25H.5zM5.75 2.5h9.75v1.25H5.75z\"></path>" } };
  var name = 'AlignRight';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

AlignRightIcon.defaultProps = {
  size: 'small'
};

function AppsIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M14.63 2.38V1.5h-1.25v.88h-.88v1.25h.88v.87h1.25v-.87h.87V2.38h-.87zm-2.1 2.96a5.79 5.79 0 00-2.39.6L10 6a.3.3 0 01-.3-.3V2.75A1.25 1.25 0 008.47 1.5H1.75A1.25 1.25 0 00.5 2.75v3A1.51 1.51 0 002 7.29a1.46 1.46 0 00.6-.14 4.44 4.44 0 012-.57A1.52 1.52 0 016.2 8a1.52 1.52 0 01-1.6 1.42 4.44 4.44 0 01-2-.57 1.46 1.46 0 00-.6-.14 1.51 1.51 0 00-1.5 1.51v3a1.25 1.25 0 001.25 1.28h6.72a1.25 1.25 0 001.25-1.25v-2.92A.3.3 0 0110 10a.27.27 0 01.12 0 5.79 5.79 0 002.39.6 2.67 2.67 0 100-5.32zM13.78 9a1.68 1.68 0 01-1.25.45 4.61 4.61 0 01-1.87-.49 1.57 1.57 0 00-.66-.18 1.55 1.55 0 00-1.55 1.55v2.92h-6.7v-3A.26.26 0 012 10h.09l.21.09a5 5 0 002.3.59A2.77 2.77 0 007.45 8 2.77 2.77 0 004.6 5.33a5 5 0 00-2.3.59L2.09 6A.16.16 0 012 6a.26.26 0 01-.25-.26v-3h6.72v2.93A1.55 1.55 0 0010 7.22a1.57 1.57 0 00.64-.14 4.61 4.61 0 011.87-.49 1.68 1.68 0 011.27.41 1.38 1.38 0 010 1.92z\"></path>" } };
  var name = 'Apps';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

AppsIcon.defaultProps = {
  size: 'small'
};

function ArchiveIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M15.5 2.75a1.25 1.25 0 00-1.25-1.25H1.75A1.25 1.25 0 00.5 2.75v2.5h1.25v8A1.25 1.25 0 003 14.5h10a1.25 1.25 0 001.25-1.25v-8h1.25zM13 5.25v8H3v-8h10zM14.25 4H1.75V2.75h12.5z\"></path><path d=\"M7.38 8.38h1.24a.63.63 0 000-1.26H7.38a.63.63 0 000 1.26z\"></path>" } };
  var name = 'Archive';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

ArchiveIcon.defaultProps = {
  size: 'small'
};

function ArrowLeftIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M1.15 6.69l7.71-5.14.7 1-7.12 4.78H15.5v1.25H2.74l6.83 4.86-.72 1L1.15 9A1.42 1.42 0 01.5 7.83a1.4 1.4 0 01.65-1.14z\"></path>" } };
  var name = 'ArrowLeft';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

ArrowLeftIcon.defaultProps = {
  size: 'small'
};

function ArrowRightIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M14.85 6.69L7.14 1.55l-.7 1 7.12 4.75H.5v1.28h12.76l-6.83 4.86.72 1L14.85 9a1.42 1.42 0 00.65-1.15 1.4 1.4 0 00-.65-1.16z\"></path>" } };
  var name = 'ArrowRight';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

ArrowRightIcon.defaultProps = {
  size: 'small'
};

function ArrowsHorizontalIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M9.25 6.12V4.87h-7l3-2.05-.71-1L.59 4.45A1.29 1.29 0 000 5.5a1.29 1.29 0 00.59 1l3.93 2.72.71-1-3-2.06zm6.16 3.33l-3.93-2.67-.71 1 3 2.06h-7v1.25h7.03l-3 2 .71 1 3.93-2.67a1.23 1.23 0 000-2.1z\"></path>" } };
  var name = 'ArrowsHorizontal';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

ArrowsHorizontalIcon.defaultProps = {
  size: 'small'
};

function ArrowsVerticalIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M6.12 6.75H4.87v7.05l-2.05-3-1 .71 2.67 3.93a1.29 1.29 0 001 .59 1.29 1.29 0 001-.59l2.67-3.93-1-.71-2.06 3zM9.45.59L6.78 4.52l1 .71 2.06-3v7.02h1.25v-7l2 3 1-.71L11.55.59a1.23 1.23 0 00-2.1 0z\"></path>" } };
  var name = 'ArrowsVertical';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

ArrowsVerticalIcon.defaultProps = {
  size: 'small'
};

function BackspaceIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M14.6 2.5H4.49a1.25 1.25 0 00-1 .51L.39 7.26a1.26 1.26 0 000 1.48L3.48 13a1.26 1.26 0 001 .51H14.6a1.25 1.25 0 001.25-1.25V3.75A1.25 1.25 0 0014.6 2.5zm0 9.75H4.49L1.4 8l3.09-4.25H14.6z\"></path><path d=\"M7.86 10.55l1.99-1.72 1.99 1.72.82-.94L10.81 8l1.85-1.61-.82-.94-1.99 1.72-1.99-1.72-.82.94L8.9 8 7.04 9.61l.82.94z\"></path>" } };
  var name = 'Backspace';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

BackspaceIcon.defaultProps = {
  size: 'small'
};

function BarcodeIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M0 2.53h2.49v10.95H0zm11 0h2.49v10.95H11zm-6.02 0h1.24v10.95H4.98zm2.49 0h1.24v10.95H7.47zm7.29 0H16v10.95h-1.24z\"></path>" } };
  var name = 'Barcode';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

BarcodeIcon.defaultProps = {
  size: 'small'
};

function BoldIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M11.19 7.45A3.49 3.49 0 0013 4.32C13 1.65 10.93 0 7.91 0H2.06v16h6.19c3.5 0 5.69-1.76 5.69-4.69a4 4 0 00-2.75-3.86zm-7.88-6.2h4.6a4.36 4.36 0 012.86.87 2.71 2.71 0 011 2.2c0 .94-.43 2.51-3.36 2.51h-5.1zm8.31 12.54a5.3 5.3 0 01-3.37 1H3.31V8.08h4.35a7.29 7.29 0 013.68.84 2.62 2.62 0 011.35 2.39 3.05 3.05 0 01-1.07 2.48z\"></path>" } };
  var name = 'Bold';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

BoldIcon.defaultProps = {
  size: 'small'
};

function BoxPackedIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M14.12 4L8.62.85a1.28 1.28 0 00-1.24 0L1.88 4a1.25 1.25 0 00-.63 1.09V11a1.25 1.25 0 00.63 1l5.5 3.11a1.28 1.28 0 001.24 0l5.5-3.11a1.25 1.25 0 00.63-1V5.05A1.25 1.25 0 0014.12 4zm-6.74 9.71l-2.13-1.2v-5.3l2.13 1.16zM8 7.29L5.92 6.15l4.81-2.67 2.09 1.18zm0-5.35l1.46.82-4.84 2.69-1.44-.79zM2.5 5.71l1.5.82v5.27L2.5 11zm6.12 8V8.37l4.88-2.66V11z\"></path>" } };
  var name = 'BoxPacked';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

BoxPackedIcon.defaultProps = {
  size: 'small'
};

function BoxUnpackedIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M15.66 7l-.91-2.68L8.62.85a1.28 1.28 0 00-1.24 0L1.25 4.32.34 7a1.24 1.24 0 00.58 1.5l.33.18V11a1.25 1.25 0 00.63 1l5.5 3.11a1.28 1.28 0 001.24 0l5.5-3.11a1.25 1.25 0 00.63-1V8.68l.33-.18a1.24 1.24 0 00.58-1.5zM10 9.87l-.48-1.28L14 6.13l.44 1.28zM8 1.94L13.46 5 8 8 2.54 5zM1.52 7.41L2 6.13l4.48 2.46L6 9.87zm1 1.95l4.25 2.32.62-1.84v3.87L2.5 11zM13.5 11l-4.88 2.71V9.84l.63 1.84 4.25-2.32z\"></path>" } };
  var name = 'BoxUnpacked';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

BoxUnpackedIcon.defaultProps = {
  size: 'small'
};

function BriefcaseIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M15 3.75h-3.49L11.11 2a1 1 0 00-1-.77H6A1 1 0 005 2l-.4 1.73H1a1 1 0 00-1 1v9a1 1 0 001 1h14a1 1 0 001-1v-9a1 1 0 00-1-.98zM6.17 2.5h3.76l.29 1.25H5.88zM14.75 5v2.5H1.25V5zm-13.5 8.5V8.75H6V9a1 1 0 001 1h2a1 1 0 001-1v-.25h4.75v4.75z\"></path>" } };
  var name = 'Briefcase';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

BriefcaseIcon.defaultProps = {
  size: 'small'
};

function BrowserIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<ellipse cx=\"3.72\" cy=\"4.02\" rx=\".67\" ry=\".62\"></ellipse><path d=\"M6.29 4.65A.65.65 0 007 4a.67.67 0 00-1.38 0 .65.65 0 00.67.65z\"></path><ellipse cx=\"8.87\" cy=\"4.02\" rx=\".67\" ry=\".63\"></ellipse><path d=\"M14.25 1.5H1.75A1.25 1.25 0 00.5 2.75v10.5a1.25 1.25 0 001.25 1.25h12.5a1.25 1.25 0 001.25-1.25V2.75a1.25 1.25 0 00-1.25-1.25zM1.75 2.75h12.5v2.5H1.75v-2.5zm0 10.5V6.5h12.5v6.75z\"></path>" } };
  var name = 'Browser';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

BrowserIcon.defaultProps = {
  size: 'small'
};

function BrowserSearchIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M.4 3.5c0-.7.6-1.2 1.3-1.2H12c.7 0 1.3.6 1.3 1.2v.6h-1v-.6c0-.2-.1-.3-.3-.3H1.7c-.2 0-.3.1-.3.3v8c0 .2.1.3.3.3H12c.2 0 .3-.1.3-.3v-.6h1v.6c0 .7-.6 1.2-1.3 1.2H1.7c-.7 0-1.3-.6-1.3-1.2v-8z\"></path><path d=\"M7.2 6.6H.9v-1h6.3v1zm7.8 5.3l-2.9-2.4.6-.7 2.9 2.4-.6.7z\"></path><path d=\"M10 9.7c1.6 0 2.8-1.1 2.8-2.4S11.6 4.8 10 4.8C8.4 4.8 7.2 6 7.2 7.3S8.4 9.7 10 9.7zm0 .9c2.1 0 3.7-1.5 3.7-3.4S12 3.9 10 3.9c-2.1 0-3.7 1.5-3.7 3.4s1.6 3.3 3.7 3.3z\"></path>" } };
  var name = 'BrowserSearch';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

BrowserSearchIcon.defaultProps = {
  size: 'small'
};

function CalendarIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M14.25 2.5h-.77v-1h-1.25v1H3.68v-1H2.43v1h-.68A1.25 1.25 0 00.5 3.75v9.5a1.25 1.25 0 001.25 1.25h12.5a1.25 1.25 0 001.25-1.25v-9.5a1.25 1.25 0 00-1.25-1.25zM1.75 3.75h12.5V5H1.75V3.75zm0 9.5v-7h12.5v7z\"></path>" } };
  var name = 'Calendar';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

CalendarIcon.defaultProps = {
  size: 'small'
};

function CalendarDaysIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M14.25 2.5h-.75v-1h-1.25v1h-8.5v-1H2.5v1h-.75A1.25 1.25 0 00.5 3.75v9.5a1.25 1.25 0 001.25 1.25h12.5a1.25 1.25 0 001.25-1.25v-9.5a1.25 1.25 0 00-1.25-1.25zM1.75 3.75h12.5V5H1.75V3.75zm0 9.5v-7h12.5v7z\"></path><path d=\"M3 8h1.1v1.2H3zm0 2.4h1.1v1.2H3zM11.8 8h1.1v1.2h-1.1zm0 2.4h1.1v1.2h-1.1zM9.6 8h1.1v1.2H9.6zm0 2.4h1.1v1.2H9.6zM7.4 8h1.1v1.2H7.4zm0 2.4h1.1v1.2H7.4zM5.2 8h1.1v1.2H5.2zm0 2.4h1.1v1.2H5.2z\"></path>" } };
  var name = 'CalendarDays';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

CalendarDaysIcon.defaultProps = {
  size: 'small'
};

function CameraIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M15 3.5h-4l-.22-.65A1.24 1.24 0 009.6 2H6.4a1.24 1.24 0 00-1.18.85L5 3.5H1a1 1 0 00-1 1V13a1 1 0 001 1h14a1 1 0 001-1V4.5a1 1 0 00-1-1zm-.25 9.25H1.25v-8H5.9l.5-1.5h3.2l.5 1.5h4.65z\"></path><path d=\"M8 6a2.59 2.59 0 00-2.67 2.5A2.59 2.59 0 008 11a2.59 2.59 0 002.67-2.5A2.59 2.59 0 008 6zm0 3.75A1.35 1.35 0 016.58 8.5 1.35 1.35 0 018 7.25 1.35 1.35 0 019.42 8.5 1.35 1.35 0 018 9.75z\"></path><ellipse cx=\"12.84\" cy=\"6.63\" rx=\".67\" ry=\".63\"></ellipse>" } };
  var name = 'Camera';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

CameraIcon.defaultProps = {
  size: 'small'
};

function CashIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M14.75 2.5H1.25A1.25 1.25 0 000 3.75v8.5a1.25 1.25 0 001.25 1.25h13.5A1.25 1.25 0 0016 12.25v-8.5a1.25 1.25 0 00-1.25-1.25zM1.25 3.75h2a1.86 1.86 0 01-2 1.75zm0 8.5V10.5a1.86 1.86 0 012 1.75zm13.5 0H12.8a1.86 1.86 0 011.95-1.75zm0-3a3.1 3.1 0 00-3.2 3h-7.1a3.1 3.1 0 00-3.2-3v-2.5a3.1 3.1 0 003.2-3h7.1a3.1 3.1 0 003.2 3zm0-3.75a1.86 1.86 0 01-1.95-1.75h1.95z\"></path><path d=\"M8 5a3.1 3.1 0 00-3.2 3A3.1 3.1 0 008 11a3.1 3.1 0 003.2-3A3.1 3.1 0 008 5zm0 4.75A1.86 1.86 0 016.05 8 1.86 1.86 0 018 6.25 1.86 1.86 0 0110 8a1.86 1.86 0 01-2 1.75z\"></path>" } };
  var name = 'Cash';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

CashIcon.defaultProps = {
  size: 'small'
};

function ChatDotsIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M8 2.19c3.13 0 5.68 2.25 5.68 5s-2.55 5-5.68 5a5.65 5.65 0 01-1.89-.29l-.75-.26-.56.56a13.78 13.78 0 01-2 1.55.13.13 0 01-.07 0v-.06a6.58 6.58 0 00.15-4.29 5.25 5.25 0 01-.55-2.16c0-2.77 2.55-5 5.68-5M8 .94c-3.83 0-6.93 2.81-6.93 6.27a6.42 6.42 0 00.64 2.64 5.53 5.53 0 01-.18 3.48 1.32 1.32 0 002 1.5 14.93 14.93 0 002.16-1.71 6.78 6.78 0 002.31.36c3.83 0 6.93-2.81 6.93-6.27S11.83.94 8 .94z\"></path><ellipse cx=\"5.2\" cy=\"7.7\" rx=\".8\" ry=\".75\"></ellipse><ellipse cx=\"8\" cy=\"7.7\" rx=\".8\" ry=\".75\"></ellipse><ellipse cx=\"10.8\" cy=\"7.7\" rx=\".8\" ry=\".75\"></ellipse>" } };
  var name = 'ChatDots';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

ChatDotsIcon.defaultProps = {
  size: 'small'
};

function CheckIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path fill-rule=\"evenodd\" d=\"M15.12 2.23l-9.79 9.78L.88 7.56 0 8.44l5.33 5.34L16 3.11l-.88-.88z\"></path>" } };
  var name = 'Check';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

CheckIcon.defaultProps = {
  size: 'small'
};

function CheckCircleIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M6.53 9.02L4.58 7.07l-.88.89 2.83 2.83.88-.89 4.78-4.77-.89-.88-4.77 4.77z\"></path><path d=\"M8 .5A7.77 7.77 0 000 8a7.77 7.77 0 008 7.5A7.77 7.77 0 0016 8 7.77 7.77 0 008 .5zm0 13.75A6.52 6.52 0 011.25 8 6.52 6.52 0 018 1.75 6.52 6.52 0 0114.75 8 6.52 6.52 0 018 14.25z\"></path>" } };
  var name = 'CheckCircle';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

CheckCircleIcon.defaultProps = {
  size: 'small'
};

function ChevronDownIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M8 10.18L2.39 4.52l-.89.87 5.59 5.71a1.18 1.18 0 00.86.39 1.13 1.13 0 00.85-.39l5.7-5.7-.88-.89z\"></path>" } };
  var name = 'ChevronDown';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

ChevronDownIcon.defaultProps = {
  size: 'small'
};

function ChevronLeftIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M5.82 8l5.66-5.56-.87-.89L4.9 7.09a1.18 1.18 0 00-.39.91 1.13 1.13 0 00.39.85l5.7 5.7.89-.88z\"></path>" } };
  var name = 'ChevronLeft';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

ChevronLeftIcon.defaultProps = {
  size: 'small'
};

function ChevronRightIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M10.18 8.05l-5.66 5.56.87.89 5.71-5.59a1.18 1.18 0 00.39-.86 1.13 1.13 0 00-.39-.85L5.4 1.5l-.89.88z\"></path>" } };
  var name = 'ChevronRight';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

ChevronRightIcon.defaultProps = {
  size: 'small'
};

function ChevronUpIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M8.05 5.82l5.56 5.66.89-.87L8.91 4.9a1.18 1.18 0 00-.86-.39 1.13 1.13 0 00-.85.39l-5.7 5.7.88.89z\"></path>" } };
  var name = 'ChevronUp';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

ChevronUpIcon.defaultProps = {
  size: 'small'
};

function ChristIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M15.32 3H10V2a2 2 0 00-4 0v1H.68a.69.69 0 00-.32 1.29L1.7 5v.58a1.25 1.25 0 00.6 1.07L5 8.28v4H3.75A1.25 1.25 0 002.5 13.5V16h11v-2.5a1.25 1.25 0 00-1.25-1.25H11v-4l2.68-1.58a1.26 1.26 0 00.62-1.08V5l1.34-.71A.69.69 0 0015.32 3zM5 6.79L3 5.58V4.25h2zM7.25 2a.75.75 0 011.5 0v1h-1.5zm-1 2.25H9.7v4.13a3.62 3.62 0 01-3.45-3.9zm0 3.75a3.59 3.59 0 00.39.39 5.36 5.36 0 003.11 1.25v2.61h-3.5zm6 5.47v1.25h-8.5V13.5h8.5zm.8-7.93L11 6.78V4.25h2.05z\"></path>" } };
  var name = 'Christ';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

ChristIcon.defaultProps = {
  size: 'small'
};

function ClockIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M8 .5A7.77 7.77 0 000 8a7.77 7.77 0 008 7.5A7.77 7.77 0 0016 8 7.77 7.77 0 008 .5zm0 13.75A6.52 6.52 0 011.25 8 6.52 6.52 0 018 1.75 6.52 6.52 0 0114.75 8 6.52 6.52 0 018 14.25z\"></path><path d=\"M8.63 4.25H7.38v4.38H11V7.38H8.63V4.25z\"></path>" } };
  var name = 'Clock';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

ClockIcon.defaultProps = {
  size: 'small'
};

function CloseIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M14.41 3.27l-.82-.94L8 7.17 2.41 2.33l-.82.94L7.05 8l-5.46 4.73.82.94L8 8.83l5.59 4.84.82-.94L8.95 8l5.46-4.73z\"></path>" } };
  var name = 'Close';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

CloseIcon.defaultProps = {
  size: 'small'
};

function CodeIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M9.539.613l-3.9 14.55 1.209.324L10.746.937 9.54.612zm-5.63 3.434L.598 7.137a1.24 1.24 0 000 1.821l3.25 3.091.921-.85-3.321-3.15 3.321-3.112-.86-.89zm11.893 3.091l-3.31-3.091-.861.91 3.32 3.091-3.32 3.111.92.85 3.251-3.05a1.242 1.242 0 000-1.821z\"></path>" } };
  var name = 'Code';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

CodeIcon.defaultProps = {
  size: 'small'
};

function CogIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M.63 11.08zm.21.41v-.1zm.23.38L1 11.68zM1 11.68l-.11-.19zm-.21-.29c-.06-.1-.11-.21-.16-.31.05.1.1.21.16.31zm.32.54v-.06z\"></path><path d=\"M11.26 12.63l1.83 1.09a7.34 7.34 0 001-.94 7.48 7.48 0 001.56-2.86l-1.74-1A5.29 5.29 0 0014 8a5.29 5.29 0 00-.08-.9l1.74-1a7.45 7.45 0 00-1.33-2.58 7.54 7.54 0 00-1.24-1.22l-1.83 1.04a6 6 0 00-1.11-.53v-2A8.55 8.55 0 007.94.53a8.39 8.39 0 00-2.26.3v2a7.23 7.23 0 00-1.12.54L2.78 2.28A7.46 7.46 0 00.2 6.06l1.72 1a5.29 5.29 0 00-.08.9 5.29 5.29 0 00.08.9l-1.73 1a8 8 0 00.43 1.15c.05.1.1.21.16.31v.1l.11.19.12.19v.06a7.69 7.69 0 001.64 1.78l1.81-1.08a7.23 7.23 0 001.12.54v2a8.39 8.39 0 002.26.31 8.56 8.56 0 002.22-.3v-2a6 6 0 001.2-.48zm-2.39 1.52a7.57 7.57 0 01-.95.06 7.73 7.73 0 01-1-.06v-1.69a4.92 4.92 0 01-2.53-1.27l-1.54.92a6.22 6.22 0 01-1.08-1.61l1.56-.93a4.27 4.27 0 010-3.17l-1.56-.92a6.11 6.11 0 011.12-1.62l1.56.93A5 5 0 017 3.53V1.82a7.73 7.73 0 011-.06 7.57 7.57 0 01.95.06v1.72a4.9 4.9 0 012.4 1.26l1.59-.94a6.31 6.31 0 011.11 1.62l-1.6.94a4.35 4.35 0 01.3 1.58 4.44 4.44 0 01-.29 1.55l1.56.93a6.43 6.43 0 01-1.11 1.61l-1.58-.93a5 5 0 01-2.49 1.28z\"></path><path d=\"M7.92 5.49A2.59 2.59 0 005.25 8a2.59 2.59 0 002.67 2.51A2.6 2.6 0 0010.6 8a2.6 2.6 0 00-2.68-2.51zM8 9.2A1.35 1.35 0 016.55 8 1.35 1.35 0 018 6.7 1.35 1.35 0 019.39 8 1.35 1.35 0 018 9.2z\"></path>" } };
  var name = 'Cog';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

CogIcon.defaultProps = {
  size: 'small'
};

function ColorPaletteIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M7.8.6h1c.7 0 1.3.2 1.9.4 2.1.7 3.6 2.1 4.6 4.1.4.8.5 1.6.6 2.4v1.3c0 .2 0 .4-.1.6-.3.6-.8 1-1.5 1h-1.9c-.4 0-.8.1-1.1.3-.6.4-.8 1-.7 1.6l.3.9c0 .2.1.4.1.6-.1.8-.6 1.3-1.4 1.4-.1 0-.2 0-.3.1H7.7c-.4 0-.8-.1-1.2-.1-2-.4-3.6-1.4-4.8-3C.8 11 .3 9.7.3 8.3v-.7c.1-.4.1-.8.2-1.1.4-1.6 1.3-3 2.6-4C4.5 1.4 6.1.8 7.9.7 7.7.6 7.7.6 7.8.6zm5.5 8.9h.9c.3 0 .7-.3.7-.6V7.1c-.2-1.3-.8-2.5-1.7-3.4-1.4-1.4-3.2-2.1-5.1-2.1-.5 0-1 0-1.4.1-1.8.4-3.2 1.2-4.3 2.6-.8 1-1.3 2.2-1.3 3.6 0 .5 0 1.1.2 1.6.4 1.5 1.3 2.7 2.5 3.7 1.1.8 2.3 1.2 3.7 1.3h1.9c.5-.1.7-.5.6-.9-.1-.2-.2-.5-.2-.7-.2-.6-.1-1.3.2-1.8.5-1 1.4-1.4 2.4-1.5.3-.1.6-.1.9-.1z\"></path><path d=\"M6.4 5.2c0 .6-.5 1.2-1.2 1.3-.4.1-.8 0-1.1-.3-.7-.6-.6-1.6.2-2 .7-.5 1.7-.3 2 .5.1.1.1.3.1.5zM5 5.6c.1 0 .2 0 .3-.1.2-.1.2-.4 0-.5-.2-.2-.3-.2-.5-.1-.1.1-.2.2-.2.3 0 .1.1.2.2.3.1 0 .1 0 .2.1zm7 1.6c-.7 0-1.3-.4-1.4-1.1-.1-.5.1-.9.5-1.2.6-.4 1.4-.3 1.9.2.7.7.3 1.8-.5 2.1-.1 0-.2.1-.3.1 0-.1-.1-.2-.2-.1zm0-1c.1 0 .1 0 0 0 .3 0 .4-.2.4-.3 0-.1-.1-.3-.2-.3h-.4c-.2 0-.3.2-.3.3 0 .1.1.3.3.3h.2zM5 8.5c0 .6-.6 1.2-1.2 1.3-.5.1-1-.1-1.3-.6-.4-.5-.3-1.3.2-1.7.8-.6 2-.2 2.2.7.1.1.1.2.1.3zm-1.4-.4c-.2 0-.4.2-.5.3 0 .2.2.3.4.4.3.1.5-.1.5-.3.1-.1-.1-.3-.4-.4.1 0 0 0 0 0zm6.3-4.3c0 .6-.3.9-.7 1.2-.6.3-1.4.2-1.8-.4-.4-.5-.3-1.3.3-1.7.8-.6 1.9-.2 2.2.7v.2zm-1.4-.3c-.3 0-.4.2-.4.3 0 .2.1.3.3.4.2.1.3 0 .4-.1.1 0 .1-.1.2-.2 0-.2-.2-.4-.5-.4z\"></path>" } };
  var name = 'ColorPalette';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

ColorPaletteIcon.defaultProps = {
  size: 'small'
};

function CopyIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M13.49 3L10.74.37A1.22 1.22 0 009.86 0h-4a1.25 1.25 0 00-1.22 1.25v11a1.25 1.25 0 001.25 1.25h6.72a1.25 1.25 0 001.25-1.25V3.88a1.22 1.22 0 00-.37-.88zm-.88 9.25H5.89v-11h2.72v2.63a1.25 1.25 0 001.25 1.25h2.75zm0-8.37H9.86V1.25l2.75 2.63z\"></path><path d=\"M10.11 14.75H3.39v-11H4V2.5h-.61a1.25 1.25 0 00-1.25 1.25v11A1.25 1.25 0 003.39 16h6.72a1.25 1.25 0 001.25-1.25v-.63h-1.25z\"></path>" } };
  var name = 'Copy';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

CopyIcon.defaultProps = {
  size: 'small'
};

function CreditCardIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M2.55 9.75h2V11h-2z\"></path><path d=\"M15.32 2.5H.68a.69.69 0 00-.68.71v9.58a.69.69 0 00.68.71h14.64a.69.69 0 00.68-.71V3.21a.69.69 0 00-.68-.71zm-.57 1.25V5H1.25V3.75zm-13.5 8.5V7.5h13.5v4.75z\"></path>" } };
  var name = 'CreditCard';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

CreditCardIcon.defaultProps = {
  size: 'small'
};

function DesktopIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M14.25 1.5H1.75A1.25 1.25 0 00.5 2.75v7.5a1.25 1.25 0 001.25 1.25H6.1v1.75H4v1.25h8v-1.25H9.91V11.5h4.34a1.25 1.25 0 001.25-1.25v-7.5a1.25 1.25 0 00-1.25-1.25zM8.66 13.25H7.35V11.5h1.31zm5.59-3H1.75v-7.5h12.5z\"></path>" } };
  var name = 'Desktop';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

DesktopIcon.defaultProps = {
  size: 'small'
};

function DiscountCircleIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M10.09 4.37a.62.62 0 00-.85.23l-3.57 6.18a.62.62 0 00.23.85.55.55 0 00.31.08.63.63 0 00.54-.31l3.57-6.18a.61.61 0 00-.23-.85zM7.35 6.43a2.16 2.16 0 00-2.06-2.24 2.17 2.17 0 00-2.07 2.24 2.17 2.17 0 002.07 2.25 2.16 2.16 0 002.06-2.25zm-2.06 1a.93.93 0 01-.82-1 .92.92 0 01.82-1 .91.91 0 01.81 1 .92.92 0 01-.81 1zm5.42-.11a2.16 2.16 0 00-2.06 2.24 2.16 2.16 0 002.06 2.25 2.17 2.17 0 002.07-2.25 2.17 2.17 0 00-2.07-2.24zm0 3.24a.92.92 0 01-.81-1 .92.92 0 01.81-1 .92.92 0 01.82 1 .93.93 0 01-.82 1z\"></path><path d=\"M8 .5A7.76 7.76 0 000 8a7.76 7.76 0 008 7.5A7.76 7.76 0 0016 8 7.76 7.76 0 008 .5zm0 13.75A6.52 6.52 0 011.25 8 6.52 6.52 0 018 1.75 6.52 6.52 0 0114.75 8 6.52 6.52 0 018 14.25z\"></path>" } };
  var name = 'DiscountCircle';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

DiscountCircleIcon.defaultProps = {
  size: 'small'
};

function DisketteIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M15.18 6.14l-3.81-4.23a1.24 1.24 0 00-.93-.41H1.75A1.25 1.25 0 00.5 2.75v10.5a1.25 1.25 0 001.25 1.25h12.5a1.25 1.25 0 001.25-1.25V7a1.24 1.24 0 00-.32-.86zm-6-3.39v2H4.25v-2zm5.05 10.5H1.75V2.75H3v2A1.25 1.25 0 004.25 6H9.2a1.25 1.25 0 001.25-1.25v-2L14.25 7z\"></path><path d=\"M8 7.56a2.43 2.43 0 00-2.5 2.35A2.43 2.43 0 008 12.25a2.43 2.43 0 002.5-2.34A2.43 2.43 0 008 7.56zM8 11a1.18 1.18 0 01-1.25-1.09A1.18 1.18 0 018 8.81a1.18 1.18 0 011.25 1.1A1.18 1.18 0 018 11z\"></path>" } };
  var name = 'Diskette';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

DisketteIcon.defaultProps = {
  size: 'small'
};

function DownloadIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M2.5 14.75h11V16h-11zm.39-5.45l4.27 3.88a1.26 1.26 0 001.68 0l4.27-3.88a1.25 1.25 0 00-.84-2.18H9.8V1.25A1.25 1.25 0 008.55 0h-1.1A1.25 1.25 0 006.2 1.25v5.87H3.73a1.25 1.25 0 00-.84 2.18zm.84-.93h3.72V1.25h1.1v7.12h3.72L8 12.25 3.73 8.37z\"></path>" } };
  var name = 'Download';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

DownloadIcon.defaultProps = {
  size: 'small'
};

function DragIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M15.46 7l-3.2-2.19-.71 1 2.29 1.57H8.62V2.16l1.57 2.29 1-.71L9 .54a1.25 1.25 0 00-2 0l-2.22 3.2 1 .71 1.59-2.29v5.22H2.16l2.29-1.57-.71-1L.54 7a1.25 1.25 0 000 2l3.2 2.19.71-1-2.29-1.57h5.21v5.22l-1.56-2.29-1 .71L7 15.46a1.25 1.25 0 002.06 0l2.19-3.2-1-.71-1.63 2.29V8.62h5.22l-2.29 1.57.71 1L15.46 9a1.25 1.25 0 000-2z\"></path>" } };
  var name = 'Drag';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

DragIcon.defaultProps = {
  size: 'small'
};

function DragDotsIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path fill-rule=\"evenodd\" d=\"M7.375 3.67c0-.645-.56-1.17-1.25-1.17s-1.25.525-1.25 1.17c0 .646.56 1.17 1.25 1.17s1.25-.524 1.25-1.17zm0 8.66c0-.646-.56-1.17-1.25-1.17s-1.25.524-1.25 1.17c0 .645.56 1.17 1.25 1.17s1.25-.525 1.25-1.17zm-1.25-5.5c.69 0 1.25.525 1.25 1.17 0 .645-.56 1.17-1.25 1.17S4.875 8.645 4.875 8c0-.645.56-1.17 1.25-1.17zm5-3.16c0-.645-.56-1.17-1.25-1.17s-1.25.525-1.25 1.17c0 .646.56 1.17 1.25 1.17s1.25-.524 1.25-1.17zm-1.25 7.49c.69 0 1.25.524 1.25 1.17 0 .645-.56 1.17-1.25 1.17s-1.25-.525-1.25-1.17c0-.646.56-1.17 1.25-1.17zM11.125 8c0-.645-.56-1.17-1.25-1.17s-1.25.525-1.25 1.17c0 .645.56 1.17 1.25 1.17s1.25-.525 1.25-1.17z\"></path>" } };
  var name = 'DragDots';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

DragDotsIcon.defaultProps = {
  size: 'small'
};

function DrinkIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<circle cx=\"4.96\" cy=\"9.98\" r=\".63\"></circle><circle cx=\"5.9\" cy=\"8.55\" r=\".31\"></circle><path fill-rule=\"evenodd\" d=\"M15.15 9v-.09a2.45 2.45 0 000-.27v-.33a2.21 2.21 0 01-.15-.25v-.27c0-.09 0-.17-.08-.25a1.43 1.43 0 01-.08-.22v-.05a1.6 1.6 0 01-.1-.23 1.86 1.86 0 00-.1-.2l-.12-.23v-.09a6.41 6.41 0 00-1-1.24h-2.75l.65-2.44a.67.67 0 01.32-.4.61.61 0 01.51 0l1.87.71.45-1.16L12.7 1a1.88 1.88 0 00-2.49 1.27l-.73 2.78H7.31a3.15 3.15 0 00-3.23-2.86 3.13 3.13 0 00-3.23 3A3 3 0 002.79 8a2.21 2.21 0 010 .25v.31a2.45 2.45 0 000 .27v.45A6.06 6.06 0 008.9 15.1a6.06 6.06 0 006.25-5.85zM8.9 13.85a4.81 4.81 0 01-5-4.6A4.41 4.41 0 015.06 6.3h7.69a4.4 4.4 0 011.15 3 4.81 4.81 0 01-5 4.55zM2.1 5.23a1.89 1.89 0 012-1.79 1.93 1.93 0 012 1.61H4.53a6.07 6.07 0 00-1 1.24.56.56 0 010 .08l-.12.23a1.42 1.42 0 00-.08.18A1.8 1.8 0 012.1 5.23z\"></path>" } };
  var name = 'Drink';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

DrinkIcon.defaultProps = {
  size: 'small'
};

function DropIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M8 12.09a1.74 1.74 0 01-1.25-.49 1.1 1.1 0 01-.36-.8.63.63 0 00-.63-.63.62.62 0 00-.62.63 2.33 2.33 0 00.73 1.69 3 3 0 002.13.85.63.63 0 100-1.25z\"></path><path d=\"M9.25 1.25C9.06.23 8.43 0 8 0S6.94.23 6.75 1.25C6 5.2 2.5 7 2.5 10.82A5.35 5.35 0 008 16a5.35 5.35 0 005.5-5.18C13.5 7 10 5.2 9.25 1.25zM8 14.75a4.1 4.1 0 01-4.25-3.93c0-1.66.85-2.9 1.84-4.33A12.85 12.85 0 008 1.48v-.1.1a12.85 12.85 0 002.39 5c1 1.43 1.84 2.67 1.84 4.33A4.1 4.1 0 018 14.75z\"></path>" } };
  var name = 'Drop';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

DropIcon.defaultProps = {
  size: 'small'
};

function DrumsIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M11.68 4.8c-.16-.07-.33-.13-.51-.19l1.91-3.3L12 .69 9.9 4.31A11.61 11.61 0 008 4.16a11.88 11.88 0 00-1.82.14L4.1.69 3 1.31l1.91 3.28a4.53 4.53 0 00-.59.21c-1.58.64-1.82 1.52-1.82 2v5.9c0 .46.24 1.34 1.82 2a9.94 9.94 0 003.68.61 9.94 9.94 0 003.68-.63c1.58-.65 1.82-1.53 1.82-2V6.79c0-.47-.24-1.35-1.82-1.99zM4.79 6a6.77 6.77 0 01.76-.25l.79 1.37 1.08-.63-.56-1A10.6 10.6 0 018 5.41a11.67 11.67 0 011.23.07l-.56 1 1.08.63.78-1.34c1.1.3 1.72.76 1.72 1.06s-.32.54-1 .83a8.72 8.72 0 01-3.25.5c-2.64 0-4.25-.89-4.25-1.37 0-.21.32-.54 1.04-.79zm6.42 7.57a8.72 8.72 0 01-3.21.49c-2.64 0-4.25-.89-4.25-1.37v-1.23a6.18 6.18 0 00.57.27 9.94 9.94 0 003.68.63 9.94 9.94 0 003.68-.63 6.18 6.18 0 00.57-.27v1.23c0 .2-.32.54-1.04.83zm0-2.95a8.72 8.72 0 01-3.21.49c-2.64 0-4.25-.89-4.25-1.37V8.51a6.18 6.18 0 00.57.27A9.94 9.94 0 008 9.41a9.94 9.94 0 003.68-.63 6.18 6.18 0 00.57-.27v1.23c0 .2-.32.54-1.04.83z\"></path>" } };
  var name = 'Drums';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

DrumsIcon.defaultProps = {
  size: 'small'
};

function DuplicateIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M8.869 6.092V3.955h1.25v2.137h2.118v1.25h-2.118v2.213h-1.25V7.342H6.636v-1.25H8.87z\"></path><path fill-rule=\"evenodd\" d=\"M15.5 10.76c0 .69-.56 1.25-1.25 1.25H4.623c-.69 0-1.25-.56-1.25-1.25V2.75c0-.69.56-1.25 1.25-1.25h9.627c.69 0 1.25.56 1.25 1.25v8.01zm-1.25 0H4.623V2.75h9.627v8.01z\"></path><path d=\"M1.75 13.25h9.615v-.62h1.25v.62c0 .69-.56 1.25-1.25 1.25H1.75c-.69 0-1.25-.56-1.25-1.25v-8C.5 4.56 1.06 4 1.75 4h1.005v1.25H1.75v8z\"></path>" } };
  var name = 'Duplicate';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

DuplicateIcon.defaultProps = {
  size: 'small'
};

function EcosystemIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M11 8a2.64 2.64 0 00-.53-1.59l1.33-1.32a2.22 2.22 0 00.82.17 1.94 1.94 0 002-1.88 2 2 0 00-4 0 1.76 1.76 0 00.24.88L9.53 5.59A3.14 3.14 0 008 5.19a3 3 0 00-2.93 2.19h-.69A2 2 0 002.5 6.13 1.94 1.94 0 00.5 8a1.94 1.94 0 002 1.88 2 2 0 001.88-1.25h.69A3 3 0 008 10.82 2.91 2.91 0 0011 8zm1.62-5.24a.69.69 0 01.75.62.76.76 0 01-1.5 0 .7.7 0 01.75-.62zM2.5 8.63A.7.7 0 011.75 8a.7.7 0 01.75-.62.7.7 0 01.75.62.7.7 0 01-.75.63zm5.5.94A1.67 1.67 0 016.25 8 1.66 1.66 0 018 6.44 1.67 1.67 0 019.75 8 1.68 1.68 0 018 9.57z\"></path><path d=\"M2.5 4.38a2 2 0 00.82-.17L5.08 6A3.73 3.73 0 016 5.13L4.26 3.38a1.76 1.76 0 00.24-.88 1.94 1.94 0 00-2-1.87 1.94 1.94 0 00-2 1.87 1.94 1.94 0 002 1.88zm0-2.5a.7.7 0 01.75.62.7.7 0 01-.75.63.7.7 0 01-.75-.63.7.7 0 01.75-.62zm11 9.75a2 2 0 00-.82.17L10.92 10a3.73 3.73 0 01-.93.84l1.74 1.74a1.75 1.75 0 00-.23.88 2 2 0 004 0 1.94 1.94 0 00-2-1.83zm0 2.5a.7.7 0 01-.75-.63.76.76 0 011.5 0 .7.7 0 01-.75.63z\"></path>" } };
  var name = 'Ecosystem';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

EcosystemIcon.defaultProps = {
  size: 'small'
};

function EditIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M15.49 7.3h-1.16v6.35H1.67V3.28H8V2H1.67A1.21 1.21 0 00.5 3.28v10.37a1.21 1.21 0 001.17 1.25h12.66a1.21 1.21 0 001.17-1.25z\"></path><path d=\"M10.56 2.87L6.22 7.22l-.44.44-.08.08-1.52 3.16a1.08 1.08 0 001.45 1.45l3.14-1.53.53-.53.43-.43 4.34-4.36.45-.44.25-.25a2.18 2.18 0 000-3.08 2.17 2.17 0 00-1.53-.63 2.19 2.19 0 00-1.54.63l-.7.69-.45.44zM5.51 11l1.18-2.43 1.25 1.26zm2-3.36l3.9-3.91 1.3 1.31L8.85 9zm5.68-5.31a.91.91 0 01.65.27.93.93 0 010 1.31l-.25.24-1.3-1.3.25-.25a.88.88 0 01.69-.25z\"></path>" } };
  var name = 'Edit';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

EditIcon.defaultProps = {
  size: 'small'
};

function EllipsisIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M8 2.5a1.22 1.22 0 011.25 1.17A1.21 1.21 0 018 4.84a1.21 1.21 0 01-1.25-1.17A1.22 1.22 0 018 2.5zm0 8.66a1.17 1.17 0 11-1.25 1.17A1.21 1.21 0 018 11.16zm0-4.33a1.17 1.17 0 110 2.34 1.17 1.17 0 110-2.34z\"></path>" } };
  var name = 'Ellipsis';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

EllipsisIcon.defaultProps = {
  size: 'small'
};

function ExclamationCircleIcon(props) {
  var svgDataByHeight = { "16": { "width": 17, "path": "<path fill-rule=\"evenodd\" d=\"M15.35 8c0 3.377-2.945 6.25-6.75 6.25S1.85 11.377 1.85 8 4.795 1.75 8.6 1.75 15.35 4.623 15.35 8zm1.25 0c0 4.142-3.582 7.5-8 7.5S.6 12.142.6 8C.6 3.858 4.182.5 8.6.5s8 3.358 8 7.5zM9.229 3.101l-.014 7.3-1.25-.002.014-7.3 1.25.002zm.016 9.249a.65.65 0 10-1.3 0 .65.65 0 001.3 0z\"></path>" } };
  var name = 'ExclamationCircle';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

ExclamationCircleIcon.defaultProps = {
  size: 'small'
};

function ExclamationTriangleIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M15.35 12.81L9 2.08a1.22 1.22 0 00-2 0L.65 12.81a1.14 1.14 0 001 1.69h12.66a1.14 1.14 0 001.04-1.69zm-13.66.55L8 2.64l6.31 10.72z\"></path><path d=\"M7.32 5.45h1.25V10H7.32z\"></path><ellipse cx=\"7.95\" cy=\"11.9\" rx=\".67\" ry=\".7\"></ellipse>" } };
  var name = 'ExclamationTriangle';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

ExclamationTriangleIcon.defaultProps = {
  size: 'small'
};

function ExternalLinkIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M14.21 1.5H10v1.25h3.08L7.9 7.21l.82 1 5.53-4.77V7h1.25V2.79a1.29 1.29 0 00-1.29-1.29z\"></path><path d=\"M12.25 13.25H1.75v-8.5H7.5V3.5h-6a1 1 0 00-1 1v9a1 1 0 001 1h11a1 1 0 001-1v-4h-1.25z\"></path>" } };
  var name = 'ExternalLink';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

ExternalLinkIcon.defaultProps = {
  size: 'small'
};

function EyeIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M8 5.5A2.59 2.59 0 005.33 8 2.59 2.59 0 008 10.5 2.59 2.59 0 0010.67 8 2.59 2.59 0 008 5.5zm0 3.75A1.35 1.35 0 016.58 8 1.35 1.35 0 018 6.75 1.35 1.35 0 019.42 8 1.35 1.35 0 018 9.25z\"></path><path d=\"M8 2.5A8.11 8.11 0 000 8a8.11 8.11 0 008 5.5A8.11 8.11 0 0016 8a8.11 8.11 0 00-8-5.5zm5.4 7.5A6.91 6.91 0 018 12.25 6.91 6.91 0 012.6 10a7.2 7.2 0 01-1.27-2A7.2 7.2 0 012.6 6 6.91 6.91 0 018 3.75 6.91 6.91 0 0113.4 6a7.2 7.2 0 011.27 2 7.2 7.2 0 01-1.27 2z\"></path>" } };
  var name = 'Eye';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

EyeIcon.defaultProps = {
  size: 'small'
};

function EyeOffIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M8 2.5a9.77 9.77 0 00-2.53.32l1 1.05A8.78 8.78 0 018 3.75 6.91 6.91 0 0113.4 6a7.2 7.2 0 011.27 2 7.2 7.2 0 01-1.27 2c-.12.13-.24.26-.37.38l.89.89A8.24 8.24 0 0016 8a8.11 8.11 0 00-8-5.5zm5 9.56l-.9-.9-6.97-6.91-1-1-1.19-1.19-.88.88 1 1A8.25 8.25 0 000 8a8.11 8.11 0 008 5.5 9.05 9.05 0 003.82-.79l1.24 1.23.88-.88-1-1zM6.66 7.54l1.67 1.67a1.47 1.47 0 01-.36 0A1.35 1.35 0 016.55 8a1.07 1.07 0 01.11-.46zM8 12.25A6.91 6.91 0 012.6 10a7.2 7.2 0 01-1.27-2A7.2 7.2 0 012.6 6 6.49 6.49 0 014 4.84l1.74 1.79A2.33 2.33 0 005.3 8 2.59 2.59 0 008 10.5a2.78 2.78 0 001.32-.33l1.58 1.58a8 8 0 01-2.9.5z\"></path>" } };
  var name = 'EyeOff';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

EyeOffIcon.defaultProps = {
  size: 'small'
};

function FileIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M13.13 4.13L9.37.37A1.26 1.26 0 008.48 0H3.75A1.25 1.25 0 002.5 1.25v13.5A1.25 1.25 0 003.75 16h8.5a1.25 1.25 0 001.25-1.25V5a1.26 1.26 0 00-.37-.87zm-.88 10.62h-8.5V1.25h3.48V5a1.25 1.25 0 001.25 1.27h3.77zm0-9.73H8.48V1.25L12.25 5z\"></path>" } };
  var name = 'File';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

FileIcon.defaultProps = {
  size: 'small'
};

function FileAltIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M13.13 4.13L9.37.37A1.26 1.26 0 008.48 0H3.75A1.25 1.25 0 002.5 1.25v13.5A1.25 1.25 0 003.75 16h8.5a1.25 1.25 0 001.25-1.25V5a1.26 1.26 0 00-.37-.87zm-.88 10.62h-8.5V1.25h3.48V5a1.25 1.25 0 001.25 1.27h3.77zm0-9.73H8.48V1.25L12.25 5z\"></path><path d=\"M5 7.5h6v1.25H5zM5 10h6v1.25H5z\"></path>" } };
  var name = 'FileAlt';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

FileAltIcon.defaultProps = {
  size: 'small'
};

function FingerprintIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M11.57 4.87a.62.62 0 00-.05.88c1 1.11 1.1 4.79.51 7.22a.63.63 0 00.46.76h.15a.63.63 0 00.61-.47c.6-2.48.65-6.75-.8-8.36a.63.63 0 00-.88-.03zM8 4.1a4.67 4.67 0 011.89.39.62.62 0 10.5-1.14A5.88 5.88 0 008 2.85C5 2.85 2.57 5 2.57 7.64a13.5 13.5 0 01-.49 4.65.62.62 0 00.34.81.52.52 0 00.24.05.63.63 0 00.58-.38 14.34 14.34 0 00.58-5.13C3.82 5.69 5.7 4.1 8 4.1z\"></path><path d=\"M13.6 2.44A8.27 8.27 0 008 .29a8.5 8.5 0 00-3.7.84A.62.62 0 004 2a.63.63 0 00.84.29A7.38 7.38 0 018 1.54c3.65 0 6.73 2.79 6.73 6.1a.63.63 0 00.63.62.62.62 0 00.64-.62 7 7 0 00-2.4-5.2zM2.16 3.54a.64.64 0 00-.87.16A7.05 7.05 0 000 7.63a.63.63 0 00.62.63.62.62 0 00.62-.62 5.74 5.74 0 011.08-3.23.62.62 0 00-.16-.87zM8 5.41a2.9 2.9 0 00-2.2.8.61.61 0 000 .88.62.62 0 00.88 0A1.83 1.83 0 018 6.66a1.62 1.62 0 011.65 1.18c.33.93 0 4.93-.55 6.4a.63.63 0 00.38.8.78.78 0 00.21 0 .62.62 0 00.59-.42A18 18 0 0011 11a10.9 10.9 0 00-.12-3.53A2.87 2.87 0 008 5.41zM5.68 8.34a.62.62 0 00-.57.66 11.09 11.09 0 01-.79 4.65.62.62 0 00.18.86.6.6 0 00.34.11.61.61 0 00.52-.29 11.93 11.93 0 001-5.43.62.62 0 00-.68-.56z\"></path><path d=\"M7.9 7.66a.63.63 0 00-.52.72 15.66 15.66 0 01-.78 5.95.63.63 0 00.29.84.63.63 0 00.83-.29 16.6 16.6 0 00.9-6.71.62.62 0 00-.72-.51z\"></path>" } };
  var name = 'Fingerprint';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

FingerprintIcon.defaultProps = {
  size: 'small'
};

function FireIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M9.32 15.653a.812.812 0 01-.086-.855c.176-.342.245-.733.2-1.118a2.106 2.106 0 00-.267-.779 2.027 2.027 0 00-.541-.606 3.96 3.96 0 01-1.481-2.282c-1.708 2.239-1.053 3.51-.235 4.63a.748.748 0 01-.014.901.87.87 0 01-.394.283.838.838 0 01-.478.023c-1.105-.27-2.145-.784-2.85-1.603a4.686 4.686 0 01-.906-1.555 4.811 4.811 0 01-.263-1.797s-.133-2.463 2.837-4.876c0 0 3.51-2.978 2.292-5.18a.621.621 0 01.112-.653.558.558 0 01.623-.147l.146.058a7.63 7.63 0 012.96 3.5c.58 1.413.576 3.06.184 4.527.325-.292.596-.641.801-1.033l.029-.064c.198-.477.821-.325 1.055-.013.086.137 2.292 3.343 1.107 6.048a5.516 5.516 0 01-1.84 2.027 6.127 6.127 0 01-2.138.893.834.834 0 01-.472-.038.867.867 0 01-.381-.29zM7.554 7.892a.422.422 0 01.55.146c.04.059.066.126.075.198l.045.349c.02.511.014 1.045.213 1.536.206.504.526.95.932 1.298a3.06 3.06 0 011.16 1.422c.22.564.25 1.19.084 1.773a4.123 4.123 0 001.39-.757l.103-.084c.336-.277.613-.623.813-1.017.201-.393.322-.825.354-1.269.065-1.025-.284-2.054-.827-2.972-.248.36-.59.639-.985.804-.247.105-.509.17-.776.19a.792.792 0 01-.439-.1.832.832 0 01-.321-.328.825.825 0 01-.035-.729c.412-.972.54-2.05.365-3.097a5.874 5.874 0 00-1.642-3.16c-.156 2.205-2.417 4.258-2.881 4.7a3.537 3.537 0 01-.224.194c-2.426 1.965-2.26 3.755-2.26 3.834a3.678 3.678 0 00.459 2.043c.365.645.89 1.177 1.52 1.54C4.5 12.808 4.5 10.89 7.183 8.14l.372-.25z\"></path>" } };
  var name = 'Fire';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

FireIcon.defaultProps = {
  size: 'small'
};

function FlagIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M14.27 1.48a1.3 1.3 0 00-.65.18 6.32 6.32 0 01-3 1.1c-1.66 0-3.65-1-5.65-1a11.41 11.41 0 00-3.18.46v-.09a.63.63 0 00-1.25 0v11.76a.63.63 0 101.25 0V11a10.56 10.56 0 013.18-.46c1.66 0 4.4 1 6.45 1A5.86 5.86 0 0015 10.11a1.17 1.17 0 00.47-.93V2.66a1.21 1.21 0 00-1.2-1.18zm0 7.65a4.58 4.58 0 01-2.87 1.08 17.73 17.73 0 01-3.29-.49 16 16 0 00-3.16-.48A12.3 12.3 0 002 9.57v-6.1A9.85 9.85 0 014.93 3a11.59 11.59 0 012.78.48 11.9 11.9 0 002.87.52 7.5 7.5 0 003.67-1.27z\"></path>" } };
  var name = 'Flag';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

FlagIcon.defaultProps = {
  size: 'small'
};

function FontIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M4.51 2.6L.25 13.67h1.34l1.49-3.86h4l1.52 3.86h1.34L5.68 2.6a.63.63 0 00-1.17 0zm-.95 6l1.54-4 1.53 4zm9.35-2.54a2.8 2.8 0 00-3 2.08l1.21.31a1.6 1.6 0 011.78-1.14c.77 0 1.59.26 1.59 1v.75c-.27 0-.63.09-.94.13a9.12 9.12 0 00-2.5.52 2.06 2.06 0 00-1.41 2.23 1.94 1.94 0 00.88 1.44 3 3 0 001.62.43 4.39 4.39 0 001.36-.22 2.92 2.92 0 001-.52v.61h1.25V8.3c0-1.3-1.14-2.24-2.84-2.24zm.22 6.33a2.4 2.4 0 01-1.91-.07.64.64 0 01-.32-.52c-.1-.89.82-1.16 2.8-1.38l.76-.1c-.19 1.68-.94 1.94-1.33 2.07z\"></path>" } };
  var name = 'Font';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

FontIcon.defaultProps = {
  size: 'small'
};

function ForbiddenIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M8 .5A7.77 7.77 0 000 8a7.77 7.77 0 008 7.5A7.77 7.77 0 0016 8 7.77 7.77 0 008 .5zM1.25 8A6 6 0 013 3.85L12.09 13A7.12 7.12 0 018 14.25 6.52 6.52 0 011.25 8zM13 12.15L3.91 3A7.12 7.12 0 018 1.75 6.52 6.52 0 0114.75 8 6 6 0 0113 12.15z\"></path>" } };
  var name = 'Forbidden';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

ForbiddenIcon.defaultProps = {
  size: 'small'
};

function GiftBoxIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M15.5 6a1.25 1.25 0 00-1.25-1.25h-1.06a2.19 2.19 0 00.23-1A2.22 2.22 0 0011.2 1.5 3.78 3.78 0 008 3.07 3.78 3.78 0 004.8 1.5a2.22 2.22 0 00-2.22 2.22 2.19 2.19 0 00.23 1H1.75A1.25 1.25 0 00.5 6v2.5h1.25v4.79A1.25 1.25 0 003 14.5h10a1.25 1.25 0 001.25-1.25V8.46h1.25zm-4.3-3.25a1 1 0 010 2H8.68a2.36 2.36 0 012.52-2zm-6.4 0a2.36 2.36 0 012.52 2H4.8a1 1 0 010-1.95zM1.75 6h4.37v1.21H1.75zm4.37 7.29H3V8.46h3.12zm1.26 0V6h1.24v7.29zm5.62 0H9.88V8.46H13zm1.25-6H9.88V6h4.37z\"></path>" } };
  var name = 'GiftBox';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

GiftBoxIcon.defaultProps = {
  size: 'small'
};

function GiftCardIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M2.5 11.25h2v1.25h-2z\"></path><path d=\"M14.75 4H13.3a2.1 2.1 0 00-1.87-3 4.24 4.24 0 00-2.84 1 3.42 3.42 0 00-.59.67A3.42 3.42 0 007.41 2a4.24 4.24 0 00-2.84-1A2.1 2.1 0 002.7 4H1.25A1.25 1.25 0 000 5.25v8.5A1.25 1.25 0 001.25 15h13.5A1.25 1.25 0 0016 13.75v-8.5A1.25 1.25 0 0014.75 4zM9.42 2.94a3 3 0 012-.69.85.85 0 010 1.7H8.74a2.32 2.32 0 01.68-1.01zm-4.85-.69a3 3 0 012 .69 2.32 2.32 0 01.68 1H4.57a.85.85 0 010-1.7zm-3.32 3h13.5V6.5H1.25V5.25zm0 8.5V9h13.5v4.75z\"></path>" } };
  var name = 'GiftCard';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

GiftCardIcon.defaultProps = {
  size: 'small'
};

function GlassesIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M15.86 9.16l-1.43-5.31a1.88 1.88 0 00-1.81-1.37h-.44v1.26h.44a.63.63 0 01.6.46L14 7.06a3.9 3.9 0 00-1.71-.39 3.64 3.64 0 00-3.7 3H7.42a3.64 3.64 0 00-3.7-3A3.87 3.87 0 002 7.06l.78-2.86a.63.63 0 01.6-.46h.44V2.48h-.44a1.88 1.88 0 00-1.81 1.37L.14 9.16a3.19 3.19 0 00-.14.94 3.59 3.59 0 003.72 3.42 3.71 3.71 0 003.62-2.59h1.32a3.71 3.71 0 003.62 2.59A3.59 3.59 0 0016 10.1a3.19 3.19 0 00-.14-.94zm-12.14 3.1a2.33 2.33 0 01-2.46-2.16 2.33 2.33 0 012.46-2.17 2.34 2.34 0 012.47 2.17 2.34 2.34 0 01-2.47 2.16zm8.56 0a2.34 2.34 0 01-2.47-2.16 2.34 2.34 0 012.47-2.17 2.33 2.33 0 012.46 2.17 2.33 2.33 0 01-2.46 2.16z\"></path>" } };
  var name = 'Glasses';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

GlassesIcon.defaultProps = {
  size: 'small'
};

function GlobeIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M16 7.38A7.82 7.82 0 008 .5a7.82 7.82 0 00-8 6.88v1.24a7.82 7.82 0 008 6.88 7.82 7.82 0 008-6.88V7.38zm-1.25 0h-3a11.34 11.34 0 00-.43-2.54 7.6 7.6 0 001.75-1 6 6 0 011.65 3.54zm-9.18 0a9.69 9.69 0 01.37-2.14A8.43 8.43 0 008 5.5a8.49 8.49 0 002.09-.26 10.2 10.2 0 01.37 2.14zm4.92 1.24a9.59 9.59 0 01-.37 2.14 8.53 8.53 0 00-4.18 0 9.69 9.69 0 01-.37-2.14zm.4-5A11.82 11.82 0 0010 2a6.89 6.89 0 012 1 6.57 6.57 0 01-1.14.66zm-2.6-1.86a10 10 0 011.38 2.3A7.63 7.63 0 018 4.25a7.56 7.56 0 01-1.67-.19 9.82 9.82 0 011.38-2.3h.58zm-3.15 1.9A6.57 6.57 0 014 3a6.89 6.89 0 012-1 10.38 10.38 0 00-.86 1.66zM3 3.83a7.6 7.6 0 001.75 1 11 11 0 00-.43 2.54h-3A6 6 0 013 3.83zM1.28 8.62h3a11 11 0 00.43 2.54 7.6 7.6 0 00-1.75 1 6 6 0 01-1.68-3.54zm3.86 3.72A10.38 10.38 0 006 14a6.89 6.89 0 01-2-1 6.57 6.57 0 011.14-.66zm2.57 1.9a9.82 9.82 0 01-1.38-2.3 7.43 7.43 0 013.34 0 9.76 9.76 0 01-1.38 2.3h-.58zm3.15-1.9a6.57 6.57 0 011.19.66 7.24 7.24 0 01-2 1 11.48 11.48 0 00.81-1.66zm2.14-.17a7.6 7.6 0 00-1.75-1 10.8 10.8 0 00.43-2.54h3A6 6 0 0113 12.17z\"></path>" } };
  var name = 'Globe';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

GlobeIcon.defaultProps = {
  size: 'small'
};

function GuitarIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M14.17 3.59L16 1.76 14.24 0l-1.83 1.83v.85l-1.8 1.83a4.18 4.18 0 00-2.34-.85 3.73 3.73 0 00-2.8 1.07 4.61 4.61 0 00-1 1.34.79.79 0 01-.23.34 1.77 1.77 0 01-.39 0 2.8 2.8 0 00-2.46.84A4.73 4.73 0 000 10.8 5.46 5.46 0 005.38 16a4.76 4.76 0 003.39-1.38 2.8 2.8 0 00.83-2.46 1.76 1.76 0 010-.39.85.85 0 01.34-.23 4.42 4.42 0 001.34-1 3.71 3.71 0 001.07-2.79 4.11 4.11 0 00-.85-2.35l1.83-1.83zm-3.05 4.19a2.46 2.46 0 01-.72 1.88 3.23 3.23 0 01-1 .78 1.94 1.94 0 00-.69.47 1.57 1.57 0 00-.34 1.34 1.6 1.6 0 01-.48 1.51 3.86 3.86 0 01-5.44-.22 4.17 4.17 0 01-1.24-2.79 3.55 3.55 0 011-2.65 1.61 1.61 0 011.51-.48 1.56 1.56 0 001.34-.34 2.15 2.15 0 00.48-.69 3 3 0 01.77-1 2.47 2.47 0 011.88-.72 3 3 0 011.52.5L7.4 7.73l.88.88 2.34-2.35a3 3 0 01.5 1.52z\"></path><path d=\"M5.83 8.33a1.76 1.76 0 00-1.29.51 1.82 1.82 0 000 2.57 1.88 1.88 0 001.38.59 1.75 1.75 0 001.24-.51 1.82 1.82 0 000-2.57 1.93 1.93 0 00-1.33-.59zm.47 2.27a.64.64 0 01-.9-.9.56.56 0 01.38-.15.74.74 0 01.45.2.6.6 0 01.07.85z\"></path>" } };
  var name = 'Guitar';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

GuitarIcon.defaultProps = {
  size: 'small'
};

function HeartIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M14.37 2.56a3.92 3.92 0 00-3-1 4.1 4.1 0 00-1.82.52A9.18 9.18 0 008 3.06a9.35 9.35 0 00-1.49-1 3.85 3.85 0 00-1.77-.52A4.07 4.07 0 001.63 2.6 4 4 0 00.35 5.52a3.83 3.83 0 00.88 2.33 33.87 33.87 0 005.7 6.2l.39-.49-.38.49a1.67 1.67 0 001.06.42 1.71 1.71 0 001.08-.42 37.42 37.42 0 006.06-6.73 3.5 3.5 0 00.47-1.74 4 4 0 00-1.24-3.02zm-.26 4.06a37.1 37.1 0 01-5.81 6.46.56.56 0 01-.28.13.51.51 0 01-.29-.14 32.77 32.77 0 01-5.49-5.94 2.74 2.74 0 01-.64-1.61 2.75 2.75 0 01.88-2 2.79 2.79 0 012.16-.72h.1a2.73 2.73 0 011.19.38A10.23 10.23 0 017.24 4l.76.63.76-.63a9 9 0 011.34-.86 2.91 2.91 0 011.26-.39h.1a2.68 2.68 0 012.07.68 2.78 2.78 0 01.87 2 2.18 2.18 0 01-.29 1.19z\"></path>" } };
  var name = 'Heart';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

HeartIcon.defaultProps = {
  size: 'small'
};

function HistoryIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M8.06.56A8.05 8.05 0 001.24 4.2V1.55H0V5a1.16 1.16 0 001.15 1.14h3.44V4.9H2.27a6.79 6.79 0 015.79-3.1 6.48 6.48 0 016.7 6.2 6.48 6.48 0 01-6.7 6.2A6.48 6.48 0 011.36 8H.12a7.71 7.71 0 007.94 7.44A7.71 7.71 0 0016 8 7.71 7.71 0 008.06.56z\"></path><path d=\"M7.44 4.28v4.34h3.6V7.38H8.68v-3.1H7.44z\"></path>" } };
  var name = 'History';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

HistoryIcon.defaultProps = {
  size: 'small'
};

function HomeIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M15.5 14.69h-1.25V7.78a.62.62 0 00-.25-.47L8.4 2.7a.65.65 0 00-.81 0L2 7.31a.62.62 0 00-.22.47v6.91H.5V7.78a1.87 1.87 0 01.68-1.44l5.62-4.6a1.88 1.88 0 012.39 0l5.63 4.6a1.87 1.87 0 01.68 1.44z\"></path><path d=\"M11.05 12.11H9.8A1.72 1.72 0 008 10.49a1.72 1.72 0 00-1.8 1.62H5a3 3 0 013-2.87 3 3 0 013.05 2.87zm-6.1 0H6.2v2.58H4.95zm4.85 0h1.25v2.58H9.8z\"></path>" } };
  var name = 'Home';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

HomeIcon.defaultProps = {
  size: 'small'
};

function InfiniteIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M12.07 4.25c-1.62 0-3 .94-4.07 2.79-1.08-1.85-2.45-2.79-4.07-2.79A3.84 3.84 0 000 8a3.84 3.84 0 003.93 3.75c1.62 0 3-.94 4.07-2.79 1.08 1.85 2.45 2.79 4.07 2.79A3.84 3.84 0 0016 8a3.84 3.84 0 00-3.93-3.75zM3.93 10.5A2.6 2.6 0 011.25 8a2.6 2.6 0 012.68-2.5c1.25 0 2.29.82 3.18 2.5-.89 1.68-1.93 2.5-3.18 2.5zm8.14 0c-1.25 0-2.29-.82-3.18-2.5.89-1.68 1.93-2.5 3.18-2.5A2.6 2.6 0 0114.75 8a2.6 2.6 0 01-2.68 2.5z\"></path>" } };
  var name = 'Infinite';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

InfiniteIcon.defaultProps = {
  size: 'small'
};

function InfoCircleIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M7.37 6.7h1.25v5H7.37z\"></path><circle cx=\"8\" cy=\"4.85\" r=\".65\"></circle><path d=\"M8 .5A7.77 7.77 0 000 8a7.77 7.77 0 008 7.5A7.77 7.77 0 0016 8 7.77 7.77 0 008 .5zm0 13.75A6.52 6.52 0 011.25 8 6.52 6.52 0 018 1.75 6.52 6.52 0 0114.75 8 6.52 6.52 0 018 14.25z\"></path>" } };
  var name = 'InfoCircle';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

InfoCircleIcon.defaultProps = {
  size: 'small'
};

function InvoiceIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M5.44 7.47h5.26v1.25H5.44zm0 2.36h5.26v1.25H5.44zm0-4.76h5.26v1.25H5.44z\"></path><path d=\"M11.34 1L9.64.28 8.08 1 6.41.28 4.84 1 2.46 0v16l2.38-1 1.57.69L8.08 15l1.56.69 1.7-.69 2.2 1V0zm.94 13.11l-.92-.41-1.69.69-1.57-.72-1.68.69-1.55-.69-1.15.47V1.86l1.15.47 1.55-.69 1.68.69 1.57-.69 1.69.69.92-.41z\"></path>" } };
  var name = 'Invoice';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

InvoiceIcon.defaultProps = {
  size: 'small'
};

function ItalicIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M13.5 1.25V0H4.71v1.25h3.67l-2.02 13.5H2.5V16h8.79v-1.25H7.62l2.02-13.5h3.86z\"></path>" } };
  var name = 'Italic';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

ItalicIcon.defaultProps = {
  size: 'small'
};

function LifeRingIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M8 .5A7.77 7.77 0 000 8a7.77 7.77 0 008 7.5A7.77 7.77 0 0016 8 7.77 7.77 0 008 .5zm5.38 3.73l-1.59 1.6A4.42 4.42 0 0010 4.3l1.6-1.58a6.5 6.5 0 011.78 1.51zM8 10.9A3.07 3.07 0 014.8 8 3.07 3.07 0 018 5.1 3.07 3.07 0 0111.2 8 3.07 3.07 0 018 10.9zm2.39-8.74L8.65 3.89H7.36L5.64 2.14A7.35 7.35 0 018 1.75a7 7 0 012.39.41zm-5.95.54L6 4.29a4.45 4.45 0 00-1.79 1.53l-1.6-1.58A6.5 6.5 0 014.44 2.7zM1.91 5.3L3.67 7a3.83 3.83 0 00-.12 1 4.32 4.32 0 00.1.88l-1.77 1.76a5.85 5.85 0 010-5.34zm.66 6.41l1.61-1.59A4.34 4.34 0 006 11.71L4.44 13.3a6.38 6.38 0 01-1.87-1.59zm3.07 2.15l1.72-1.75H8a5.52 5.52 0 00.71-.05l1.73 1.73a7.27 7.27 0 01-2.44.46 7.35 7.35 0 01-2.36-.39zm6-.6l-1.58-1.58a4.35 4.35 0 001.77-1.57l1.6 1.6a6.68 6.68 0 01-1.79 1.55zm2.48-2.63l-1.77-1.76a3.57 3.57 0 00.1-.87 3.75 3.75 0 00-.12-1l1.76-1.7a5.83 5.83 0 010 5.33z\"></path>" } };
  var name = 'LifeRing';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

LifeRingIcon.defaultProps = {
  size: 'small'
};

function LightbulbIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M8 0a5.35 5.35 0 00-5.5 5.18c0 3.23 2.59 3.23 2.59 5.17v3.06A2.77 2.77 0 008 16a2.78 2.78 0 002.92-2.59v-3.06c0-1.94 2.59-1.94 2.59-5.17A5.35 5.35 0 008 0zm0 14.75a1.54 1.54 0 01-1.65-1.34V12.2h3.31v1.21A1.55 1.55 0 018 14.75zm3.1-7.16a3.75 3.75 0 00-1.43 2.76V11H6.34v-.6a3.75 3.75 0 00-1.43-2.81 2.87 2.87 0 01-1.16-2.41A4.1 4.1 0 018 1.25a4.1 4.1 0 014.25 3.93 2.87 2.87 0 01-1.16 2.41z\"></path><path d=\"M8 2.66a3 3 0 00-2.13.85 2.33 2.33 0 00-.73 1.69.62.62 0 00.62.63.63.63 0 00.63-.63 1.1 1.1 0 01.36-.8A1.74 1.74 0 018 3.91a.63.63 0 100-1.25z\"></path>" } };
  var name = 'Lightbulb';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

LightbulbIcon.defaultProps = {
  size: 'small'
};

function LinkIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M8 6.1a.31.31 0 00-.45.32 2.47 2.47 0 00.51 1.22l.15.13A3 3 0 019.08 10a3.63 3.63 0 01-3.55 3.44 3 3 0 01-2.11-.85 3 3 0 01-.85-2.22A3.55 3.55 0 013.63 8a3.66 3.66 0 011.5-.91A5.19 5.19 0 015 6v-.16a4.84 4.84 0 00-2.31 1.3 4.5 4.5 0 00-.2 6.37 4.16 4.16 0 003 1.22 4.79 4.79 0 003.38-1.42 4.52 4.52 0 00.21-6.38A4.16 4.16 0 008 6.1z\"></path><path d=\"M13.46 2.54a4.16 4.16 0 00-3-1.22 4.79 4.79 0 00-3.37 1.42 4.52 4.52 0 00-.21 6.38A4.21 4.21 0 008 9.9a.31.31 0 00.45-.31 2.41 2.41 0 00-.52-1.23l-.15-.13A3 3 0 016.92 6a3.63 3.63 0 013.55-3.44 3 3 0 012.11.85 3 3 0 01.85 2.22A3.55 3.55 0 0112.37 8a3.66 3.66 0 01-1.5.91 5.19 5.19 0 01.13 1.14v.16a4.84 4.84 0 002.31-1.3 4.5 4.5 0 00.15-6.37z\"></path>" } };
  var name = 'Link';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

LinkIcon.defaultProps = {
  size: 'small'
};

function LinkOffIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M8 3.63a3.57 3.57 0 012.49-1.06 2.9 2.9 0 013 3A3.65 3.65 0 0110.73 9l1 1a4.71 4.71 0 001.54-1 4.79 4.79 0 001.42-3.38 4.16 4.16 0 00-1.22-3 4.16 4.16 0 00-3-1.22 4.79 4.79 0 00-3.38 1.34 4.71 4.71 0 00-1 1.54l1 1A3.6 3.6 0 018 3.63zm-6.31-.17l2.59 2.59a4.71 4.71 0 00-1.54 1 4.79 4.79 0 00-1.42 3.38 4.16 4.16 0 001.22 3 4.16 4.16 0 003 1.22 4.79 4.79 0 003.38-1.42 4.71 4.71 0 001-1.54l2.74 2.74.89-.88-11-11zM8 12.37a3.57 3.57 0 01-2.49 1.06 2.9 2.9 0 01-3-3A3.65 3.65 0 015.26 7L9 10.74a3.57 3.57 0 01-1 1.63z\"></path>" } };
  var name = 'LinkOff';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

LinkOffIcon.defaultProps = {
  size: 'small'
};

function ListIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M3.8 3.05H16v1.26H3.8zm0 4.29H16V8.6H3.8zm0 4.36H16v1.26H3.8zM1.25 2.5A1.22 1.22 0 012.5 3.68a1.22 1.22 0 01-1.25 1.17A1.22 1.22 0 010 3.68 1.22 1.22 0 011.25 2.5zm0 4.3a1.18 1.18 0 110 2.35 1.18 1.18 0 110-2.35zm0 4.35a1.18 1.18 0 110 2.35 1.18 1.18 0 110-2.35z\"></path>" } };
  var name = 'List';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

ListIcon.defaultProps = {
  size: 'small'
};

function LocationIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M8 .52a5.39 5.39 0 00-5.59 5.15c0 5 3.88 8.61 5.17 9.66a.66.66 0 00.84 0c1.29-1.05 5.17-4.63 5.17-9.66A5.39 5.39 0 008 .52zM8 14a15.2 15.2 0 01-2.46-2.76 9.85 9.85 0 01-1.88-5.57A4.14 4.14 0 018 1.77a4.14 4.14 0 014.34 3.9c0 4.08-2.96 7.16-4.34 8.33z\"></path><path d=\"M8 2.54a2.73 2.73 0 00-2.84 2.65A2.74 2.74 0 008 7.84a2.75 2.75 0 002.83-2.65A2.74 2.74 0 008 2.54zm0 4.05a1.49 1.49 0 01-1.57-1.4A1.49 1.49 0 018 3.79a1.5 1.5 0 011.58 1.4A1.5 1.5 0 018 6.59z\"></path>" } };
  var name = 'Location';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

LocationIcon.defaultProps = {
  size: 'small'
};

function LockIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M7.25 11.2v1.42h1.5V11.2a1.48 1.48 0 00.85-1.32A1.55 1.55 0 008 8.38a1.55 1.55 0 00-1.6 1.5 1.48 1.48 0 00.85 1.32z\"></path><path d=\"M14.75 5H13.5A5.29 5.29 0 008 0a5.29 5.29 0 00-5.5 5H1.25A1.25 1.25 0 000 6.25v8.5A1.25 1.25 0 001.25 16h13.5A1.25 1.25 0 0016 14.75v-8.5A1.25 1.25 0 0014.75 5zM8 1.25A4.05 4.05 0 0112.25 5h-8.5A4.05 4.05 0 018 1.25zm6.75 13.5H1.25v-8.5h13.5z\"></path>" } };
  var name = 'Lock';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

LockIcon.defaultProps = {
  size: 'small'
};

function LockOpenIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M7.25 11.2v1.42h1.5V11.2a1.48 1.48 0 00.85-1.32A1.55 1.55 0 008 8.38a1.55 1.55 0 00-1.6 1.5 1.48 1.48 0 00.85 1.32z\"></path><path d=\"M14.75 5H13.5A5.29 5.29 0 008 0a5.45 5.45 0 00-5.32 3.75H4a4.28 4.28 0 014-2.5A4.05 4.05 0 0112.25 5h-11A1.25 1.25 0 000 6.25v8.5A1.25 1.25 0 001.25 16h13.5A1.25 1.25 0 0016 14.75v-8.5A1.25 1.25 0 0014.75 5zm0 9.75H1.25v-8.5h13.5z\"></path>" } };
  var name = 'LockOpen';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

LockOpenIcon.defaultProps = {
  size: 'small'
};

function LogOutIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M1.3 3.75h5.88V2.5H1.3A1.25 1.25 0 00.05 3.75v8.5A1.25 1.25 0 001.3 13.5h5.88v-1.25H1.3z\"></path><path d=\"M15.4 7l-4-2.74-.71 1 3.08 2.1H4.71v1.26h9.07l-3.08 2.11.71 1L15.4 9a1.24 1.24 0 000-2z\"></path>" } };
  var name = 'LogOut';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

LogOutIcon.defaultProps = {
  size: 'small'
};

function MailIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M15 2.5H1a1 1 0 00-1 1v9a1 1 0 001 1h14a1 1 0 001-1v-9a1 1 0 00-1-1zm-1.3 1.25L8.42 8.56a.62.62 0 01-.84 0L2.3 3.75zm-12.45 8.5V4.48l5.49 5a1.86 1.86 0 002.52 0l5.49-5v7.77z\"></path>" } };
  var name = 'Mail';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

MailIcon.defaultProps = {
  size: 'small'
};

function MarketingIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M14.25 2.1a1.25 1.25 0 00-1.17-.1L6.91 4.43a1.22 1.22 0 01-.46.09H2.5a1.25 1.25 0 00-1.25 1.25v.1H0v3h1.25V9a1.25 1.25 0 001.25 1.22L4 13.4a1.26 1.26 0 001.13.72h.63A1.25 1.25 0 007 12.87v-2.53l6.08 2.43a1.27 1.27 0 00.47.09 1.29 1.29 0 00.7-.22 1.25 1.25 0 00.55-1V3.13a1.25 1.25 0 00-.55-1.03zm-8.5 3.67V9H2.5V5.77zm0 7.1h-.63l-1.23-2.65h1.86zm1.62-3.72A2.29 2.29 0 007 9V5.7a2.26 2.26 0 00.37-.11l6.18-2.46v8.48zm7.46-3.03v2.5a1.25 1.25 0 000-2.5z\"></path>" } };
  var name = 'Marketing';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

MarketingIcon.defaultProps = {
  size: 'small'
};

function MateIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path fill-rule=\"evenodd\" d=\"M12.38 5.71H9.8l1-3.12a.67.67 0 01.3-.36l1.66-.87-.54-1.11-1.65.87a1.89 1.89 0 00-.9 1.06L8.48 5.7H3.62a5.67 5.67 0 00-1.87 4.19A6.06 6.06 0 008 15.75a6.06 6.06 0 006.25-5.86 5.67 5.67 0 00-1.87-4.18zM3.82 7h8.36a4.93 4.93 0 01.73 1.23H3.09A4.93 4.93 0 013.82 7zm9.43 2.94a4.53 4.53 0 01-.48 2l-1.44-1.25-1.66 1.43L8 10.67l-1.67 1.45-1.66-1.45-1.44 1.25a4.53 4.53 0 01-.48-2v-.46h10.48c.01.12.02.28.02.43zM8 14.75A5.37 5.37 0 013.94 13l.73-.64 1.66 1.45L8 12.33l1.67 1.45 1.66-1.45.73.64A5.37 5.37 0 018 14.75z\"></path>" } };
  var name = 'Mate';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

MateIcon.defaultProps = {
  size: 'small'
};

function MenuIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M.5 7.42h15v1.25H.5zm0 3.6h15v1.25H.5zm0-7.29h15v1.25H.5z\"></path>" } };
  var name = 'Menu';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

MenuIcon.defaultProps = {
  size: 'small'
};

function MobileIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M12.25 0h-8.5A1.25 1.25 0 002.5 1.25v13.5A1.25 1.25 0 003.75 16h8.5a1.25 1.25 0 001.25-1.25V1.25A1.25 1.25 0 0012.25 0zm0 14.75h-8.5V1.25h8.5z\"></path><ellipse cx=\"8\" cy=\"12.75\" rx=\".8\" ry=\".75\"></ellipse>" } };
  var name = 'Mobile';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

MobileIcon.defaultProps = {
  size: 'small'
};

function MoneyIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M12.32 8a3 3 0 00-2-.7H5.63A1.59 1.59 0 014 5.69a2 2 0 010-.25 1.59 1.59 0 011.63-1.33h4.62a1.59 1.59 0 011.57 1.33h1.5a3.08 3.08 0 00-3.07-2.83H8.67V.31H7.42v2.3H5.63a3.08 3.08 0 00-3.07 2.83 2.09 2.09 0 000 .25 3.07 3.07 0 003.07 3.07h4.74A1.59 1.59 0 0112 10.35a1.86 1.86 0 010 .34 1.59 1.59 0 01-1.55 1.24h-4.7a1.59 1.59 0 01-1.55-1.24H2.69a3.08 3.08 0 003.06 2.73h1.67v2.27h1.25v-2.27h1.7a3.08 3.08 0 003.06-2.73v-.34A3.06 3.06 0 0012.32 8z\"></path>" } };
  var name = 'Money';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

MoneyIcon.defaultProps = {
  size: 'small'
};

function MoonIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M11.47 2.18a6.49 6.49 0 013.22 5.5 6.84 6.84 0 01-7.08 6.55 7.42 7.42 0 01-3.82-1 7 7 0 01-1.9-1.65 9.47 9.47 0 003.34-.74 9.92 9.92 0 003.3-2.24 10 10 0 002.94-6.42M10.82.45a.66.66 0 00-.66.69 8.63 8.63 0 01-2.55 6.54 8.68 8.68 0 01-6.09 2.57H.66a.66.66 0 00-.58 1 8.45 8.45 0 007.53 4.39A8.15 8.15 0 0016 7.68 7.85 7.85 0 0011.07.51a.61.61 0 00-.25-.06z\"></path>" } };
  var name = 'Moon';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

MoonIcon.defaultProps = {
  size: 'small'
};

function NotificationIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M13.58 11.6l-1.33-2.18V6.33A4.36 4.36 0 0010 2.26a2.45 2.45 0 000-.38A1.94 1.94 0 008 0a1.94 1.94 0 00-2 1.88 1.64 1.64 0 000 .38 4.36 4.36 0 00-2.25 4.07v3.09L2.42 11.6a1.25 1.25 0 001.06 1.9h1.77A2.68 2.68 0 008 16a2.68 2.68 0 002.75-2.5h1.77a1.25 1.25 0 001.06-1.9zM7.25 1.88A.7.7 0 018 1.25a.7.7 0 01.75.63 6 6 0 00-.75 0 5.9 5.9 0 00-.75 0zM8 14.75a1.44 1.44 0 01-1.5-1.25h3A1.44 1.44 0 018 14.75zm-4.52-2.5l1.34-2.17.18-.31V6.33a4 4 0 01.6-2.12A2.68 2.68 0 018 3.12a2.68 2.68 0 012.4 1.09 4 4 0 01.6 2.12v3.44l.18.31 1.34 2.17z\"></path>" } };
  var name = 'Notification';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

NotificationIcon.defaultProps = {
  size: 'small'
};

function ObeliskIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M12.25 12.25h-.37L11 2.87a1.21 1.21 0 00-.38-.78L8.87.35a1.25 1.25 0 00-1.74 0L5.34 2.09a1.21 1.21 0 00-.34.78l-.84 9.38h-.41A1.26 1.26 0 002.5 13.5V16h11v-2.5a1.26 1.26 0 00-1.25-1.25zM6.2 3L8 1.25 9.8 3l.83 9.27H5.37zm6.05 11.77h-8.5V13.5h8.5z\"></path><circle cx=\"8.02\" cy=\"4.04\" r=\".62\"></circle>" } };
  var name = 'Obelisk';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

ObeliskIcon.defaultProps = {
  size: 'small'
};

function OrderedListIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M3.59 3.03h12.2v1.26H3.59zm0 4.29h12.2v1.26H3.59zm0 4.35h12.2v1.26H3.59zM.99 4.79h.49V2.52H.6v.45h.39v1.82zm.87 3.88H.91l.14-.11.3-.24c.35-.28.49-.5.49-.79A.74.74 0 001 6.8a.77.77 0 00-.81.84h.52A.34.34 0 011 7.25a.31.31 0 01.31.31.6.6 0 01-.22.44l-.87.75v.39h1.64zm-.36 3.56a.52.52 0 00.28-.48.67.67 0 00-.78-.62.71.71 0 00-.77.75h.5a.3.3 0 01.27-.32.26.26 0 110 .51H.91v.38H1c.23 0 .37.11.37.29a.29.29 0 01-.33.29.35.35 0 01-.36-.35H.21a.76.76 0 00.83.8.74.74 0 00.83-.72.53.53 0 00-.37-.53z\"></path>" } };
  var name = 'OrderedList';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

OrderedListIcon.defaultProps = {
  size: 'small'
};

function PencilIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M13.8 2.2a2.51 2.51 0 00-3.54 0l-6.9 6.91-1.76 3.62a1.26 1.26 0 001.12 1.8 1.23 1.23 0 00.55-.13l3.62-1.76 6-6 .83-.82.06-.06a2.52 2.52 0 00.02-3.56zm-.89.89a1.25 1.25 0 010 1.77l-1.77-1.77a1.24 1.24 0 01.86-.37 1.22 1.22 0 01.91.37zM2.73 13.27L4.29 10 6 11.71zm4.16-2.4L5.13 9.11 10.26 4 12 5.74z\"></path>" } };
  var name = 'Pencil';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

PencilIcon.defaultProps = {
  size: 'small'
};

function PesoIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M8 .52A7.77 7.77 0 000 8a7.77 7.77 0 008 7.48A7.77 7.77 0 0016 8 7.77 7.77 0 008 .52zm0 13.71A6.51 6.51 0 011.25 8 6.51 6.51 0 018 1.77 6.51 6.51 0 0114.75 8 6.51 6.51 0 018 14.23z\"></path><path d=\"M9 7.38H7A.34.34 0 016.69 7a.13.13 0 01.01 0 .34.34 0 01.3-.29h1.94a.34.34 0 01.33.29h1.25a1.59 1.59 0 00-1.58-1.54h-.32V4.21H7.37v1.25H7A1.59 1.59 0 005.44 7a1.55 1.55 0 00.35 1A1.59 1.59 0 007 8.62h2a.34.34 0 01.33.38.33.33 0 01-.33.29H7.08A.33.33 0 016.75 9H5.49a1.58 1.58 0 001.58 1.54h.31v1.25h1.24v-1.25H9A1.58 1.58 0 0010.56 9a1.51 1.51 0 00-.34-1A1.59 1.59 0 009 7.38z\"></path>" } };
  var name = 'Peso';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

PesoIcon.defaultProps = {
  size: 'small'
};

function PictureIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M13.5 6.73L11 5 7.68 7.53 6 6 2.5 8.49V11h11zm-1.25 3h-8.5v-.59L5.9 7.6l.94.86.77.7.83-.63 2.59-2 1.22.84z\"></path><ellipse cx=\"3.3\" cy=\"5.75\" rx=\".8\" ry=\".75\"></ellipse><path d=\"M14.75 2.5H1.25A1.25 1.25 0 000 3.75v8.5a1.25 1.25 0 001.25 1.25h13.5A1.25 1.25 0 0016 12.25v-8.5a1.25 1.25 0 00-1.25-1.25zm0 9.75H1.25v-8.5h13.5z\"></path>" } };
  var name = 'Picture';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

PictureIcon.defaultProps = {
  size: 'small'
};

function PixIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M11.917 11.71a2.046 2.046 0 01-1.454-.602l-2.1-2.1a.4.4 0 00-.551 0l-2.108 2.108a2.044 2.044 0 01-1.454.602h-.414l2.66 2.66c.83.83 2.177.83 3.007 0l2.667-2.668h-.253zM4.25 4.282c.55 0 1.066.214 1.454.602l2.108 2.108a.39.39 0 00.552 0l2.1-2.1a2.044 2.044 0 011.453-.602h.253L9.503 1.623a2.127 2.127 0 00-3.007 0l-2.66 2.66h.414z\"></path><path d=\"M14.377 6.496l-1.612-1.612a.307.307 0 01-.114.023h-.733c-.379 0-.75.154-1.017.422l-2.1 2.1a1.005 1.005 0 01-1.425 0L5.268 5.32a1.448 1.448 0 00-1.018-.422h-.9a.306.306 0 01-.109-.021L1.623 6.496c-.83.83-.83 2.177 0 3.008l1.618 1.618a.305.305 0 01.108-.022h.901c.38 0 .75-.153 1.018-.421L7.375 8.57a1.034 1.034 0 011.426 0l2.1 2.1c.267.268.638.421 1.017.421h.733c.04 0 .079.01.114.024l1.612-1.612c.83-.83.83-2.178 0-3.008z\"></path>" } };
  var name = 'Pix';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

PixIcon.defaultProps = {
  size: 'small'
};

function PlanetIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M8 .5A7.76 7.76 0 000 8a7.76 7.76 0 008 7.5A7.76 7.76 0 0016 8 7.76 7.76 0 008 .5zm6.71 6.8L13.48 7c-.25-.07-.27-.09-.29-.12-.15-.2-.32-.47-.48-.73 0-.09-.13-.23-.16-.31s.35-.6.51-.84a2.43 2.43 0 01.59-.45 5.87 5.87 0 011.06 2.75zM8 1.75l-.09.17a.19.19 0 010-.1c0 .06-.15.15-.25.25l-.3.29a.85.85 0 00-.08 1.08h-.12a1.05 1.05 0 00-.81.42 1.27 1.27 0 00-.2 1.07V5a3 3 0 00-.43.11l-.24.08-.64.21a1.2 1.2 0 00-.81.8 1 1 0 00.2.93 5.67 5.67 0 001.38 1.09 4.17 4.17 0 001.67.65h1.68a1.2 1.2 0 011.04.51.49.49 0 01.13.43.77.77 0 01-.15.35 2.71 2.71 0 00-.95 1.61 11.11 11.11 0 01-.48 1.38c-.12.31-.23.61-.31.85a3.32 3.32 0 01-1-.08 3.28 3.28 0 00-.5-2.12 2.24 2.24 0 01-.53-1.42 2.11 2.11 0 00-1.47-2.29 10.81 10.81 0 01-2.9-2.64A6.79 6.79 0 018 1.75zM1.25 8a5.64 5.64 0 01.12-1.16 10.29 10.29 0 002.94 2.42c.6.22.69.45.69 1.12a3.45 3.45 0 00.86 2.27A3.05 3.05 0 016 14a6.35 6.35 0 01-4.75-6zm8.32 6.08c0-.15.12-.32.18-.48a10.2 10.2 0 00.55-1.6 1.55 1.55 0 01.54-.86 1.91 1.91 0 00.57-1.3 1.71 1.71 0 00-.47-1.27 2.45 2.45 0 00-2-.9H7.35a4.77 4.77 0 01-2-1.11l.47-.16.27-.08a.79.79 0 01.38-.07l.09.15a.64.64 0 00.81.29.65.65 0 00.34-.8v-.18c-.11-.3-.24-.72-.32-1A1.42 1.42 0 008.68 4a1 1 0 00-.18-1 3.44 3.44 0 00.33-.34 1 1 0 00.22-.8 6.93 6.93 0 013.73 1.8 3 3 0 00-.79.7 9.14 9.14 0 00-.64 1.09 1.46 1.46 0 00.24 1.39c.18.31.38.61.56.86a1.58 1.58 0 001 .58c.22.06 1 .22 1.55.33a6.44 6.44 0 01-5.13 5.47z\"></path>" } };
  var name = 'Planet';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

PlanetIcon.defaultProps = {
  size: 'small'
};

function PlusCircleIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M8.64 4.33H7.39v3.05H4.34v1.25h3.05v3.05h1.25V8.63h3.05V7.38H8.64V4.33z\"></path><path d=\"M8 .5A7.77 7.77 0 000 8a7.77 7.77 0 008 7.5A7.77 7.77 0 0016 8 7.77 7.77 0 008 .5zm0 13.75A6.52 6.52 0 011.25 8 6.52 6.52 0 018 1.75 6.52 6.52 0 0114.75 8 6.52 6.52 0 018 14.25z\"></path>" } };
  var name = 'PlusCircle';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

PlusCircleIcon.defaultProps = {
  size: 'small'
};

function PrinterIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M14.25 6.57h-.75v-.05a1.26 1.26 0 00-.37-.89L9.37 1.87a1.26 1.26 0 00-.89-.37H3.75A1.25 1.25 0 002.5 2.75v3.82h-.75A1.26 1.26 0 00.5 7.85v3.84A1.26 1.26 0 001.75 13h.75v.28a1.25 1.25 0 001.25 1.22h8.5a1.25 1.25 0 001.25-1.25V13h.75a1.26 1.26 0 001.25-1.28V7.85a1.26 1.26 0 00-1.25-1.28zM3.75 2.75h4.73l3.77 3.77v.69h-8.5V2.75zm8.5 10.5h-8.5v-.92h8.5v.92zm2-1.56h-.75v-.64h-11v.64h-.74V7.85h.74v.64h11v-.67h.74z\"></path><ellipse cx=\"12.88\" cy=\"9.77\" rx=\".63\" ry=\".59\"></ellipse>" } };
  var name = 'Printer';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

PrinterIcon.defaultProps = {
  size: 'small'
};

function PyramidIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M14.77 11V8.5a1.25 1.25 0 00-1.25-1.25v-2.5a1.25 1.25 0 00-1.27-1.25h-1.87V1.25A1.26 1.26 0 009.12 0H6.88a1.26 1.26 0 00-1.26 1.25V3.5H3.75A1.25 1.25 0 002.5 4.75v2.5A1.25 1.25 0 001.23 8.5V11A1.25 1.25 0 000 12.25V16h16v-3.75A1.25 1.25 0 0014.77 11zm-2.52-6.25v2.5h-1.14l-.68-2.5zm-5.37-3.5h2.24V3.5H6.88V1.25zm-3.13 3.5h1.83l-.69 2.5H3.75zm-.91 10H1.25v-2.5h2.28zM2.48 11V8.5h2.07L3.87 11zm1.66 3.75l2.07-7.58.66-2.42h2.26l.69 2.5.34 1.25.68 2.5.34 1.25.68 2.5zm7.31-6.25h2.07V11h-1.38zm3.3 6.25h-1.59l-.68-2.5h2.27z\"></path>" } };
  var name = 'Pyramid';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

PyramidIcon.defaultProps = {
  size: 'small'
};

function QrCodeIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M14.4 5.5s0 .1 0 0c-.1.2-.2.3-.4.3s-.4-.2-.4-.3V3.3c0-.1 0-.2-.1-.2H11c-.2 0-.4-.1-.4-.3 0-.2.1-.4.3-.4h2.5c.3 0 .5.1.7.3.1.1.2.3.2.4.1.9.1 1.7.1 2.4zM5.2 7.4H3.9c-.2 0-.4-.1-.5-.2-.1-.1-.1-.3-.1-.5V4.5c0-.3.1-.5.4-.6.1.1.2 0 .3 0h2.5c.2 0 .4.1.6.3.1.1.1.2.1.3v2.2c0 .2-.1.4-.3.6-.1.1-.3.1-.4.1H5.2zm0-.6h1.2c.1 0 .1 0 .1-.1v-2c0-.1 0-.1-.1-.1H3.8c-.1 0-.1 0-.1.1v2.1c0 .1 0 .1.1.1h.1c.5-.1.9-.1 1.3-.1zm5.5 5.3H9.4c-.2 0-.4-.1-.5-.2-.1-.1-.2-.3-.2-.4V9.3c0-.3.1-.5.4-.6.1-.1.2-.1.3-.1h2.5c.2 0 .4.1.6.3.1.1.1.2.1.3v2.2c0 .3-.1.4-.3.6-.1.1-.2.1-.4.1h-1.2zm0-.6h1.2c.1 0 .1 0 .1-.1v-2c0-.1 0-.1-.1-.1H9.3c-.1 0-.1 0-.1.1v2.1c0 .1 0 .1.1.1h.1c.5-.1.9-.1 1.3-.1z\"></path><path d=\"M3.7 2.4h1.2c.2 0 .3.1.3.3.2.2.1.4-.2.4H2.3c-.1 0-.1.1-.1.1v2.2c0 .2-.1.4-.4.4-.2 0-.3-.1-.4-.3V3.3c0-.4.3-.7.6-.8h.3c.6-.1 1-.1 1.4-.1zm-2.1 9v-1.2c0-.2.1-.3.3-.3.2 0 .4.1.4.3v2.7c0 .1.1.1.1.1h2.2c.2-.2.4 0 .4.2s-.1.3-.3.4H2.5c-.4 0-.7-.3-.8-.6v-.3c-.1-.5-.1-.9-.1-1.3zm12.8 0v1.3c0 .2 0 .3-.1.5s-.3.4-.6.4h-2.3c-.2 0-.4-.1-.4-.3 0-.2.1-.4.3-.4h2.2c.1 0 .1-.1.1-.1v-2.6c0-.1 0-.2.1-.3.1-.1.3-.1.4-.1.1.1.2.2.2.3.1.4.1.9.1 1.3z\"></path><path d=\"M5.2 11.4h1.7c.1 0 .1.1.1.1v.3c0 .1-.1.2-.2.2H3.4c-.1 0-.1-.1-.1-.1v-.3c0-.1.1-.2.2-.2h1.7zm6.9-5.7V4.1c0-.1 0-.1.1-.1h.3c.1 0 .2.1.2.2v3.1c0 .1-.1.1-.2.1h-.3c-.1 0-.2-.1-.2-.2v-.5c.1-.3.1-.7.1-1zM4.7 8.6H6c.1 0 .1.1.1.1V9c0 .1-.1.2-.2.2H3.4c-.1 0-.1-.1-.1-.2v-.3c0-.1.1-.2.2-.2.4.1.8.1 1.2.1zm5.1-2.5v1.2l-.1.1h-.3c-.1 0-.2-.1-.2-.2V4.9l.1-.1h.3c.1 0 .2.1.2.2v1.1zm-5.5 4.6h-.9c-.1 0-.1-.1-.1-.1v-.3c0-.1.1-.2.2-.2h1.6c.1 0 .1.1.1.1v.3c0 .1-.1.2-.2.2h-.7zm6.4-4.2v-.7c0-.1 0-.1.1-.2h.4c.1 0 .2.1.2.2v1.5c0 .1-.1.2-.2.2h-.3c-.1 0-.2-.1-.2-.2v-.8z\"></path>" } };
  var name = 'QrCode';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

QrCodeIcon.defaultProps = {
  size: 'small'
};

function QuestionCircleIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M8 .5A7.77 7.77 0 000 8a7.77 7.77 0 008 7.5A7.77 7.77 0 0016 8 7.77 7.77 0 008 .5zm0 13.75A6.52 6.52 0 011.25 8 6.52 6.52 0 018 1.75 6.52 6.52 0 0114.75 8 6.52 6.52 0 018 14.25z\"></path><circle cx=\"7.98\" cy=\"10.95\" r=\".76\"></circle><path d=\"M9.73 4.75A2.72 2.72 0 008 4.19a2.28 2.28 0 00-2.41 2.17v.11h1.24v-.1A1.12 1.12 0 018 5.33a1 1 0 011.12 1c0 .35-.24.73-.78 1.11a2 2 0 00-1 1.46v.36h1.24V9a.76.76 0 01.23-.51A3.92 3.92 0 019.33 8l.17-.14a2 2 0 00.91-1.67 1.85 1.85 0 00-.68-1.44z\"></path>" } };
  var name = 'QuestionCircle';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

QuestionCircleIcon.defaultProps = {
  size: 'small'
};

function RealIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M7.41 7.2a1.7 1.7 0 00-1.7-1.7H2.62v5h1.25V8.9h.84a1.59 1.59 0 011.55 1.6h1.25a2.82 2.82 0 00-.77-1.95 1.71 1.71 0 00.67-1.35zm-1.7-.45a.45.45 0 010 .9H3.87v-.9z\"></path><path d=\"M8 .5A7.77 7.77 0 000 8a7.77 7.77 0 008 7.5A7.77 7.77 0 0016 8 7.77 7.77 0 008 .5zm0 13.75A6.52 6.52 0 011.25 8 6.52 6.52 0 018 1.75 6.52 6.52 0 0114.75 8 6.52 6.52 0 018 14.25z\"></path><path d=\"M13.22 8A1.59 1.59 0 0012 7.38h-2A.34.34 0 019.69 7a.13.13 0 01.01 0 .34.34 0 01.3-.3h1.91a.34.34 0 01.33.28h1.25a1.59 1.59 0 00-1.58-1.53h-.32V4.2h-1.22v1.25H10A1.6 1.6 0 008.44 7a1.55 1.55 0 00.35 1 1.59 1.59 0 001.21.62h2a.34.34 0 01.34.34V9a.33.33 0 01-.33.29h-1.93A.33.33 0 019.75 9H8.49a1.58 1.58 0 001.58 1.54h.3v1.26h1.25v-1.26H12A1.58 1.58 0 0013.56 9a1.51 1.51 0 00-.34-1z\"></path>" } };
  var name = 'Real';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

RealIcon.defaultProps = {
  size: 'small'
};

function RedoIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M7.94.56a8.05 8.05 0 016.82 3.64V1.55H16V5a1.16 1.16 0 01-1.15 1.15h-3.44V4.9h2.32a6.79 6.79 0 00-5.79-3.1A6.48 6.48 0 001.24 8a6.48 6.48 0 006.7 6.2 6.48 6.48 0 006.7-6.2h1.24a7.71 7.71 0 01-7.94 7.44A7.71 7.71 0 010 8 7.71 7.71 0 017.94.56z\"></path>" } };
  var name = 'Redo';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

RedoIcon.defaultProps = {
  size: 'small'
};

function RemoveFormatIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M5.03 2.49l.19-1.25h3.06L7.7 5.16l1.09 1.09.75-5.01h3.07l-.18 1.15 1.23.19.39-2.58h-9.9l-.21 1.4 1.09 1.09zm3.53 5.29l-1.09-1.1-4.64-4.63-.88.87 5.29 5.29-.97 6.45H4.05v1.25h2.66l.62.09.01-.09h2.23v-1.25H7.53l.8-5.36 4.56 4.56.88-.88-5.21-5.2z\"></path>" } };
  var name = 'RemoveFormat';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

RemoveFormatIcon.defaultProps = {
  size: 'small'
};

function RocketIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M2.67 10.73a3.52 3.52 0 00-.94 1.93 5 5 0 00-.07 1.1v.58h.8a5.05 5.05 0 00.88-.08 3.46 3.46 0 001.93-.94 1.76 1.76 0 00-.14-2.48 1.76 1.76 0 00-2.46-.11zm1.74 1.73a2.26 2.26 0 01-1.26.6h-.22v-.22a2.26 2.26 0 01.6-1.26.36.36 0 01.24-.08.67.67 0 01.47.22.54.54 0 01.17.74zM14.65 2.24a.91.91 0 00-.89-.89A8.75 8.75 0 007.27 3.5L5.64 5.4l-2.4-.5a1 1 0 00-.92.27l-.68.68a1 1 0 00-.28.81 1 1 0 00.45.74l2.06 1.32.13.08 3.2 3.25.08.08 1.32 2.06a1 1 0 00.74.45h.11a1 1 0 00.7-.29l.68-.68a1 1 0 00.27-.92l-.5-2.39 1.84-1.58a8.79 8.79 0 002.21-6.54zM3.11 6.15l1.32.28-.64.75-1-.67zm6.38 7.1l-.67-1 .75-.64.28 1.32zm2.39-5.11l.18.17zm-.28-.28L7.92 11 5 8.08 8.14 4.4a7.44 7.44 0 015.26-1.8 7.48 7.48 0 01-1.8 5.26z\"></path><path d=\"M11.13 6.63a1.19 1.19 0 00-.06-1.7 1.16 1.16 0 10-1.64 1.63 1.2 1.2 0 001.7.07z\"></path>" } };
  var name = 'Rocket';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

RocketIcon.defaultProps = {
  size: 'small'
};

function ScooterIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M12.37 7.53a3.67 3.67 0 00-2.5 1H7.16a.65.65 0 01-.38-.13L5 7V4h2V2.75H4.1a2.91 2.91 0 00-.33-.37 2.34 2.34 0 00-.77-.5 2.64 2.64 0 00-1-.18V4h1.75v3.16a.62.62 0 01-.09.32L2.19 9.93A2.38 2.38 0 000 12.2a2.41 2.41 0 002.5 2.3A2.41 2.41 0 005 12.2h11V11a3.54 3.54 0 00-3.63-3.47zm0 1.25A2.29 2.29 0 0114.75 11H10a2.29 2.29 0 012.37-2.22zM2.5 13.25a1.16 1.16 0 01-1.25-1.05 1.16 1.16 0 011.25-1 1.16 1.16 0 011.25 1 1.16 1.16 0 01-1.25 1.05zM4.59 11a2.38 2.38 0 00-1.06-.83L4.62 8.3 6 9.36a1.9 1.9 0 001.13.38H9A3.22 3.22 0 008.75 11z\"></path><path d=\"M14.75 1.5H11a1.25 1.25 0 00-1.3 1.25v3A1.25 1.25 0 0011 7h3.8A1.25 1.25 0 0016 5.75v-3a1.25 1.25 0 00-1.25-1.25zm0 4.25H11v-3h3.8zm-2.38 7.5a1.17 1.17 0 01-1.25-1.05H9.87a2.41 2.41 0 002.5 2.3 2.41 2.41 0 002.5-2.3h-1.25a1.16 1.16 0 01-1.25 1.05z\"></path>" } };
  var name = 'Scooter';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

ScooterIcon.defaultProps = {
  size: 'small'
};

function SearchIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M14.91 13.09l-3.68-3.21a4.86 4.86 0 00.86-2.77A5.34 5.34 0 006.59 2a5.35 5.35 0 00-5.5 5.15 5.34 5.34 0 005.5 5.15 5.71 5.71 0 003.82-1.44L14.08 14zM6.59 11a4.09 4.09 0 01-4.25-3.9 4.09 4.09 0 014.25-3.9 4.09 4.09 0 014.25 3.9A4.08 4.08 0 016.59 11z\"></path>" } };
  var name = 'Search';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

SearchIcon.defaultProps = {
  size: 'small'
};

function ShareIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path fill-rule=\"evenodd\" d=\"M8 4.67a2.14 2.14 0 002.19-2.09A2.14 2.14 0 008 .5a2.14 2.14 0 00-2.24 2.08 1.93 1.93 0 00.22.9L3.3 6.16a2.19 2.19 0 00-1.11-.3A2.14 2.14 0 000 8a2.14 2.14 0 002.19 2 2.14 2.14 0 001-.23l2.77 2.78a2.06 2.06 0 00-.18.83A2.14 2.14 0 008 15.5a2.09 2.09 0 100-4.17 2.25 2.25 0 00-1.18.33L4.09 9a1.77 1.77 0 00.15-.31h7.52A2.19 2.19 0 0013.81 10 2.14 2.14 0 0016 8a2.2 2.2 0 00-4.3-.52H4.3a1.74 1.74 0 00-.14-.38l2.67-2.72A2.33 2.33 0 008 4.67zm0-1.24a.89.89 0 00.94-.85.89.89 0 00-.94-.84.89.89 0 00-1 .84.89.89 0 001 .85zM2.19 8.8a.9.9 0 00.94-.8.9.9 0 00-.94-.84.9.9 0 00-.95.84.91.91 0 00.95.8zM14.76 8a1 1 0 01-1.89 0 1 1 0 011.89 0zm-5.87 5.42a.89.89 0 01-.94.84.85.85 0 110-1.69.89.89 0 01.94.85z\"></path>" } };
  var name = 'Share';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

ShareIcon.defaultProps = {
  size: 'small'
};

function ShoppingCartIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M13.35 10.48H4.5l-.24-1.25h9.13a1.24 1.24 0 001.22-1l.84-4a1.25 1.25 0 00-1.22-1.51H3l-.22-1.24H.5v1.25h1.25l1.5 7.84a2 2 0 00-1.54 1.93 2.09 2.09 0 002.16 2 2.08 2.08 0 002.13-2 2 2 0 00-.16-.77h5.49a2 2 0 00-.16.77 2.09 2.09 0 002.16 2 2 2 0 100-4zM14.23 4l-.84 4H4l-.74-4zM3.87 13.27A.85.85 0 013 12.5a.85.85 0 01.91-.77.84.84 0 01.9.77.84.84 0 01-.94.77zm9.48 0a.85.85 0 01-.91-.77.92.92 0 011.81 0 .85.85 0 01-.9.77z\"></path>" } };
  var name = 'ShoppingCart';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

ShoppingCartIcon.defaultProps = {
  size: 'small'
};

function ShotIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M11.37 9.85l.87-6.4a1.22 1.22 0 00-.3-1A1.24 1.24 0 0011 2H2.85a1.24 1.24 0 00-1.23 1.41l1.15 8.48A1.27 1.27 0 004 13h4.84a4.41 4.41 0 002.66 1h.14a3.9 3.9 0 002.76-1.12zM11 3.25l-.15 1.09H3l-.15-1.09zM7.23 9.72a4.28 4.28 0 00.57 2H4l-.83-6.13h7.47l-.42 3.11-1.87-1.87a3.83 3.83 0 00-1.12 2.89zm4.31 3a3.18 3.18 0 01-2.12-.94 3.21 3.21 0 01-.95-2.13 2.71 2.71 0 01.11-.86l1.91 1.92 1.91 1.91a2.73 2.73 0 01-.76.1z\"></path>" } };
  var name = 'Shot';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

ShotIcon.defaultProps = {
  size: 'small'
};

function SizeHeightIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M9 15.46l2.74-4-1-.71-2.1 3.09V2.16l2.1 3.09 1-.71L9 .54a1.25 1.25 0 00-2 0l-2.74 4 1 .71 2.12-3.09v11.68l-2.11-3.09-1 .71 2.74 4a1.25 1.25 0 001.99 0z\"></path>" } };
  var name = 'SizeHeight';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

SizeHeightIcon.defaultProps = {
  size: 'small'
};

function SizeWidthIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M15.46 7l-4-2.74-.71 1 3.09 2.11H2.16l3.09-2.1-.71-1L.54 7a1.25 1.25 0 000 2l4 2.74.71-1-3.09-2.12h11.68l-3.09 2.11.71 1 4-2.74a1.25 1.25 0 000-1.99z\"></path>" } };
  var name = 'SizeWidth';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

SizeWidthIcon.defaultProps = {
  size: 'small'
};

function SlidersIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M4 8.75h-.88V2.5H1.88v6.25H1a1 1 0 00-1 1v1.75a1 1 0 001 1h.88v1h1.24v-1H4a1 1 0 001-1V9.75a1 1 0 00-1-1zm-.25 2.5h-2.5V10h2.5zm5.75-8h-.88V2.5H7.38v.75H6.5a1 1 0 00-1 1V6a1 1 0 001 1h.88v6.5h1.24V7h.88a1 1 0 001-1V4.25a1 1 0 00-1-1zm-.25 2.5h-2.5V4.5h2.5zM15 7.35h-.88V2.5h-1.24v4.85H12a1 1 0 00-1 1v1.75a1 1 0 001 1h.88v2.4h1.24v-2.4H15a1 1 0 001-1V8.35a1 1 0 00-1-1zm-.25 2.5h-2.5V8.6h2.5z\"></path>" } };
  var name = 'Sliders';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

SlidersIcon.defaultProps = {
  size: 'small'
};

function StarIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M8 3.12l1.43 2.77.31.59.66.08 3.12.35L11.26 9l-.5.47.12.67.53 2.95-2.85-1.42-.56-.28-.57.28-2.85 1.44.53-2.95.12-.67-.5-.49-2.26-2.08 3.12-.36.66-.08.31-.59L8 3.12m0-2a.63.63 0 00-.57.33l-2 3.84-4.51.55a.59.59 0 00-.34 1l3.3 3.08-.76 4.21a.61.61 0 00.62.7.65.65 0 00.26-.05l4-2 4 2a.65.65 0 00.29.07.61.61 0 00.62-.7l-.76-4.21 3.31-3.09a.59.59 0 00-.34-1l-4.54-.51-2-3.84A.63.63 0 008 1.15z\"></path>" } };
  var name = 'Star';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

StarIcon.defaultProps = {
  size: 'small'
};

function StatsIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M1.75 13.25V1.5H.5v12a1.24 1.24 0 001.22 1H15.5v-1.25z\"></path><path d=\"M3.15 8H4.4v3.9H3.15zm3.26-4h1.26v7.9H6.41zm3.27 2h1.25v5.9H9.68zm3.27-3.5h1.25v9.4h-1.25z\"></path>" } };
  var name = 'Stats';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

StatsIcon.defaultProps = {
  size: 'small'
};

function StickyNoteIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M14.25 1.5H1.75A1.25 1.25 0 00.5 2.75v10.5a1.25 1.25 0 001.25 1.25h8.69a1.24 1.24 0 00.93-.41l3.81-4.23A1.24 1.24 0 0015.5 9V2.75a1.25 1.25 0 00-1.25-1.25zM1.75 13.25V2.75h12.5v5h-3.81A1.25 1.25 0 009.19 9v4.23zm8.69 0V9h3.81z\"></path>" } };
  var name = 'StickyNote';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

StickyNoteIcon.defaultProps = {
  size: 'small'
};

function StopIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M3 7.38h10v1.25H3z\"></path><path d=\"M8 .5A7.76 7.76 0 000 8a7.76 7.76 0 008 7.5A7.76 7.76 0 0016 8 7.76 7.76 0 008 .5zm0 13.75A6.52 6.52 0 011.25 8 6.52 6.52 0 018 1.75 6.52 6.52 0 0114.75 8 6.52 6.52 0 018 14.25z\"></path>" } };
  var name = 'Stop';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

StopIcon.defaultProps = {
  size: 'small'
};

function StoreIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M2.49 12h4.33V7.66H2.49zm1.25-3.09h1.83v1.83H3.74zm7.33-1.25a2.43 2.43 0 00-2.43 2.43v3.4H9.9v-3.4a1.18 1.18 0 112.35 0v3.4h1.25v-3.4a2.43 2.43 0 00-2.43-2.43zM2.49 5.07H13.5v1.3H2.49z\"></path><path d=\"M14.12 2.51H1.88A1.88 1.88 0 000 4.39v9.1h1.25v-9.1a.63.63 0 01.63-.63h12.24a.63.63 0 01.63.63v9.1H16v-9.1a1.88 1.88 0 00-1.88-1.88z\"></path>" } };
  var name = 'Store';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

StoreIcon.defaultProps = {
  size: 'small'
};

function SunIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M8 3.33A4.85 4.85 0 003 8a4.85 4.85 0 005 4.67A4.85 4.85 0 0013 8a4.85 4.85 0 00-5-4.67zm0 8.09A3.6 3.6 0 014.25 8 3.6 3.6 0 018 4.58 3.6 3.6 0 0111.75 8 3.6 3.6 0 018 11.42zM7.33 0h1.25v2H7.33zm0 14h1.25v2H7.33zM14 7.33h2v1.25h-2zm-14 0h2v1.25H0zM11.92 2.4h2v1.25h-2zm-9.9 9.9h2v1.25h-2zm10.33-.38h1.25v2h-1.25zm-9.9-9.9H3.7v2H2.45z\"></path>" } };
  var name = 'Sun';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

SunIcon.defaultProps = {
  size: 'small'
};

function TagIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M15 7.2L8.8 1a1.25 1.25 0 00-.88-.34h-6A1.25 1.25 0 00.66 1.91v6A1.25 1.25 0 001 8.8L7.2 15a1.24 1.24 0 00.88.36A1.28 1.28 0 009 15l6-6a1.27 1.27 0 000-1.8zm-6.9 6.89L1.91 7.92v-6h6l6.17 6.17z\"></path><ellipse cx=\"4.95\" cy=\"4.95\" rx=\"1.41\" ry=\"1.5\"></ellipse>" } };
  var name = 'Tag';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

TagIcon.defaultProps = {
  size: 'small'
};

function TelephoneIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M10.91 2.75h3a11.67 11.67 0 01-3.8 7.46 11.71 11.71 0 01-7.88 3h-.77V10.4L4 9.52l.84 1.42.59 1.06 1.07-.62a14.36 14.36 0 004.77-4.5L12 5.73l-1.22-.64-1-.52 1.09-1.82m0-1.25a1.26 1.26 0 00-1.07.61L8.75 3.93a1.24 1.24 0 00.49 1.75l1 .52a13.06 13.06 0 01-4.36 4.1L5 8.89a1.25 1.25 0 00-1-.62 1.22 1.22 0 00-.41.07L1 9.22a1.25 1.25 0 00-.79 1.18v2.85a1.25 1.25 0 001.25 1.25h.75A13 13 0 0015.14 2.88a1.26 1.26 0 00-1.25-1.38z\"></path>" } };
  var name = 'Telephone';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

TelephoneIcon.defaultProps = {
  size: 'small'
};

function TextSizeIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M6.1 2.75h3.09V4h1.25V1.5H.5V4h1.25V2.75h3.1v10.5H2.7v1.25h5.55v-1.25H6.1V2.75z\"></path><path d=\"M12.4 6.75H8.06v2.5h1.25V8h1.84v5.25H9.63v1.25h4.3v-1.25H12.4V8h1.85v1.25h1.25v-2.5h-3.1z\"></path>" } };
  var name = 'TextSize';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

TextSizeIcon.defaultProps = {
  size: 'small'
};

function TiendanubeIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M10.25 2.24a5.79 5.79 0 00-4 1.63 4.48 4.48 0 100 8.26 5.76 5.76 0 104-9.89zm0 10.24A4.49 4.49 0 015.76 8H4.48a5.74 5.74 0 00.89 3.07 3.29 3.29 0 01-.88.13 3.2 3.2 0 010-6.4A3.2 3.2 0 017.69 8H9a4.42 4.42 0 00-1.63-3.43 4.48 4.48 0 112.88 7.91z\"></path>" } };
  var name = 'Tiendanube';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

TiendanubeIcon.defaultProps = {
  size: 'small'
};

function ToolsIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M14.25 10.71L11.57 8l2.26-2.26a2.49 2.49 0 000-3.53 2.5 2.5 0 00-3.53 0l-.89.88L8 4.5 5.28 1.75a1.26 1.26 0 00-1.76 0L1.75 3.52a1.25 1.25 0 000 1.77L4.5 8l-.22.22-.89.88-1.75 3.66a1.25 1.25 0 001.67 1.67l3.62-1.75.49-.49.39-.39.19-.23 2.68 2.68a1.26 1.26 0 001.76 0l1.77-1.77a1.25 1.25 0 00.04-1.77zm-2.19-8a1.27 1.27 0 01.89.36 1.25 1.25 0 010 1.77l-1.77-1.72a1.27 1.27 0 01.88-.36zM2.63 4.4L4.4 2.64l.82.82-.87.88.88.88.88-.88 1 1-1.73 1.81zm.13 8.91l1.57-3.23L6 11.74zm4.17-2.4L5.16 9.14 10.3 4l1.76 1.76zm4.67 2.45l-2.68-2.67 1.77-1.77.93.93-.88.88.88.89.89-.89.86.87z\"></path>" } };
  var name = 'Tools';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

ToolsIcon.defaultProps = {
  size: 'small'
};

function TransferPesoIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M14.75 2.5H1.25A1.2 1.2 0 000 3.64v8.72a1.2 1.2 0 001.25 1.14h13.5A1.2 1.2 0 0016 12.36V3.64a1.2 1.2 0 00-1.25-1.14zm0 9.75H1.25v-8.5h13.5z\"></path><path d=\"M7 8.62h2a.34.34 0 01.33.38.33.33 0 01-.33.29H7.08A.33.33 0 016.75 9H5.49a1.58 1.58 0 001.58 1.54h.31v1.26h1.24v-1.26H9A1.58 1.58 0 0010.56 9a1.51 1.51 0 00-.34-1A1.59 1.59 0 009 7.38H7A.34.34 0 016.69 7a.13.13 0 01.01 0 .34.34 0 01.3-.3h1.94a.34.34 0 01.33.3h1.25a1.59 1.59 0 00-1.58-1.55h-.32V4.2H7.37v1.25H7A1.6 1.6 0 005.44 7a1.55 1.55 0 00.35 1A1.59 1.59 0 007 8.62z\"></path>" } };
  var name = 'TransferPeso';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

TransferPesoIcon.defaultProps = {
  size: 'small'
};

function TransferRealIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M10 8.52h2a.36.36 0 01.25.11.35.35 0 01.1.25.19.19 0 010 .08.32.32 0 01-.12.2.35.35 0 01-.22.08H10a.35.35 0 01-.22-.08.34.34 0 01-.12-.16l-.05-.23h-1.2v.33a1.6 1.6 0 00.52 1 1.57 1.57 0 001 .41h.43v.94h1.13v-.94h.36a1.6 1.6 0 001.56-1.41 1.09 1.09 0 000-.18 1.56 1.56 0 00-.15-.67 1.64 1.64 0 00-.43-.55 1.56 1.56 0 00-1-.36H10a.37.37 0 01-.25-.1.36.36 0 01-.11-.26.09.09 0 010-.05.3.3 0 01.12-.22.33.33 0 01.24-.13h1.92a.35.35 0 01.23.09.4.4 0 01.12.22v.25h1.2v-.33a1.63 1.63 0 00-.5-1 1.6 1.6 0 00-1.07-.42h-.31v-1h-1.15v1H10a1.57 1.57 0 00-1.07.42 1.58 1.58 0 00-.5 1v.12a1.58 1.58 0 00.47 1.12 1.53 1.53 0 001.1.47zm-6.27.29h.84a1.63 1.63 0 011.59 1.62h1.25a2.86 2.86 0 00-.79-2 1.69 1.69 0 00.68-1.34 1.71 1.71 0 00-1.71-1.71H2.48v5.05h1.25zm1.86-2.18a.47.47 0 010 .93H3.73v-.93z\"></path><path d=\"M14.75 2.5H1.25A1.2 1.2 0 000 3.64v8.72a1.2 1.2 0 001.25 1.14h13.5A1.2 1.2 0 0016 12.36V3.64a1.2 1.2 0 00-1.25-1.14zm0 9.75H1.25v-8.5h13.5z\"></path>" } };
  var name = 'TransferReal';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

TransferRealIcon.defaultProps = {
  size: 'small'
};

function TrashIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M13.11 1.88a1.27 1.27 0 00-.9-.38h-3v-.3a1.25 1.25 0 00-2.5 0v.3h-3a1.25 1.25 0 00-1.17 1.29l.41 12A1.26 1.26 0 004.2 16h7.59A1.24 1.24 0 0013 14.79l.42-12a1.28 1.28 0 00-.31-.91zM4.2 14.75l-.32-9.5h8.24l-.33 9.5zM12.16 4H3.84V2.75h8.42z\"></path><path d=\"M5 7h1.25v5H5zm2.37 0h1.25v5H7.37zm2.38 0H11v5H9.75z\"></path>" } };
  var name = 'Trash';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

TrashIcon.defaultProps = {
  size: 'small'
};

function TruckIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M15.17 7.36L13 4.92a1.25 1.25 0 00-.94-.42h-2V2.75A1.25 1.25 0 008.82 1.5H1.76A1.25 1.25 0 00.51 2.75v8.5a1.25 1.25 0 001.25 1.25h.33a2.07 2.07 0 002.13 2 2.08 2.08 0 002.14-2H10a2.07 2.07 0 002.13 2 2.08 2.08 0 002.14-2 1.26 1.26 0 001.2-1.25V8.19a1.22 1.22 0 00-.3-.83zM4.22 13.25a.82.82 0 01-.88-.75.82.82 0 01.88-.75.83.83 0 01.89.75.83.83 0 01-.89.75zm4.6-7.58v5.58H5.89a2.17 2.17 0 00-1.67-.75 2.17 2.17 0 00-1.66.75h-.8v-8.5h7.06zm1.25.08h2l1.44 1.63h-3.44zm2.08 7.5a.82.82 0 01-.88-.75.82.82 0 01.88-.75.83.83 0 01.89.75.83.83 0 01-.89.75zm0-2.75a2.17 2.17 0 00-1.66.75h-.42V8.62h4.17v2.63h-.42a2.17 2.17 0 00-1.67-.75z\"></path>" } };
  var name = 'Truck';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

TruckIcon.defaultProps = {
  size: 'small'
};

function UndoIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M8.06.56A8.05 8.05 0 001.24 4.2V1.55H0V5a1.16 1.16 0 001.15 1.14h3.44V4.9H2.27a6.79 6.79 0 015.79-3.1 6.48 6.48 0 016.7 6.2 6.48 6.48 0 01-6.7 6.2A6.48 6.48 0 011.36 8H.12a7.71 7.71 0 007.94 7.44A7.71 7.71 0 0016 8 7.71 7.71 0 008.06.56z\"></path>" } };
  var name = 'Undo';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

UndoIcon.defaultProps = {
  size: 'small'
};

function UniversityIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M16 6.28a1.23 1.23 0 00-.62-1.07l-6.74-4a1.27 1.27 0 00-1.28 0l-6.75 4a1.25 1.25 0 000 2.15l1.92 1.12v2.81a1.28 1.28 0 00.62 1.09l4.25 2.45a1.28 1.28 0 001.24 0l4.25-2.45a1.28 1.28 0 00.62-1.09V8.45l1.24-.73v2.72H16V6.28zm-3.73 5L8 13.74l-4.22-2.45V9.22l3.58 2.13a1.29 1.29 0 001.28 0l3.62-2.16zM8 10.27l-6.75-4L8 2.26l6.75 4z\"></path>" } };
  var name = 'University';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

UniversityIcon.defaultProps = {
  size: 'small'
};

function UploadIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M2.5 14.75h11V16h-11zm1.23-8.37H6.2v5.87a1.25 1.25 0 001.25 1.25h1.1a1.25 1.25 0 001.25-1.25V6.38h2.47a1.25 1.25 0 00.84-2.18L8.84.32a1.26 1.26 0 00-1.68 0L2.89 4.2a1.25 1.25 0 00.84 2.18zM8 1.25l4.27 3.88H8.55v7.12h-1.1V5.13H3.73z\"></path>" } };
  var name = 'Upload';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

UploadIcon.defaultProps = {
  size: 'small'
};

function UserIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M8 7.83c-3.08 0-5.59 2.17-5.59 4.84V16h1.27v-3.33c0-2 1.94-3.57 4.32-3.57s4.32 1.6 4.32 3.57V16h1.27v-3.33c0-2.67-2.51-4.84-5.59-4.84zm.1-1.22a3.22 3.22 0 003.1-3.31A3.21 3.21 0 008.1 0 3.21 3.21 0 005 3.3a3.22 3.22 0 003.1 3.31zm0-5.32a1.92 1.92 0 011.81 2 1.93 1.93 0 01-1.81 2 1.93 1.93 0 01-1.8-2 1.92 1.92 0 011.8-2z\"></path>" } };
  var name = 'User';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

UserIcon.defaultProps = {
  size: 'small'
};

function UserCircleIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M8 .5A7.77 7.77 0 000 8a7.77 7.77 0 008 7.5A7.77 7.77 0 0016 8 7.77 7.77 0 008 .5zM5.16 13.67A2.84 2.84 0 018 11.51a2.82 2.82 0 012.84 2.16 7.24 7.24 0 01-5.68 0zm6.84-.61a4.09 4.09 0 00-4-2.77 4.09 4.09 0 00-3.95 2.78A6.14 6.14 0 011.25 8 6.52 6.52 0 018 1.75 6.52 6.52 0 0114.75 8 6.11 6.11 0 0112 13.06z\"></path><path d=\"M8.05 4.3A2.33 2.33 0 005.8 6.7a2.33 2.33 0 002.25 2.4 2.33 2.33 0 002.25-2.4 2.33 2.33 0 00-2.25-2.4zm0 3.55a1.08 1.08 0 01-1-1.15 1.08 1.08 0 011-1.15 1.08 1.08 0 011 1.15 1.08 1.08 0 01-1 1.15z\"></path>" } };
  var name = 'UserCircle';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

UserCircleIcon.defaultProps = {
  size: 'small'
};

function UserGroupIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M5.1 7.93A2.87 2.87 0 007.87 5 2.88 2.88 0 005.1 2a2.88 2.88 0 00-2.78 3A2.88 2.88 0 005.1 7.93zm0-4.67A1.62 1.62 0 016.62 5 1.63 1.63 0 015.1 6.68 1.63 1.63 0 013.58 5 1.62 1.62 0 015.1 3.26zm7.19 5.05a2.39 2.39 0 002.3-2.46 2.39 2.39 0 00-2.3-2.47A2.39 2.39 0 0010 5.85a2.39 2.39 0 002.29 2.46zm0-3.68a1.15 1.15 0 011.05 1.22 1.15 1.15 0 01-1.05 1.21 1.15 1.15 0 01-1.06-1.21 1.15 1.15 0 011.06-1.22zm-.07 4.93a3.85 3.85 0 00-3.07 1.51A5.21 5.21 0 005.1 9.18 5 5 0 000 14h1.25a3.72 3.72 0 013.85-3.57A3.71 3.71 0 018.94 14h1.25a4.5 4.5 0 00-.32-1.69 2.54 2.54 0 012.35-1.5 2.44 2.44 0 012.53 2.33V14H16v-.86a3.69 3.69 0 00-3.78-3.58z\"></path>" } };
  var name = 'UserGroup';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

UserGroupIcon.defaultProps = {
  size: 'small'
};

function VerticalStacksIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M8 13.5H1c-.8 0-1-.2-1-1V9.4c0-.6.3-.9.9-.9H15c.7 0 1 .3 1 1v3.1c0 .7-.3.9-.9.9H8zm0-1h6.4c.4 0 .6-.1.6-.5v-2c0-.3-.1-.5-.4-.4H1.7c-.5-.1-.7 0-.7.5v1.8c0 .5.1.6.6.6H8zm.1-5h-7c-.9 0-1.1-.2-1.1-1v-3c0-.7.3-.9.9-.9h14.2c.7 0 .9.3.9.9v3.1c0 .7-.2 1-1 1-2.3-.1-4.6-.1-6.9-.1zm-.1-1h6.4c.3 0 .5 0 .5-.4V3.9c0-.3-.1-.4-.4-.4h-13c-.3 0-.5.2-.5.6v1.8c0 .5.1.6.6.6H8z\"></path>" } };
  var name = 'VerticalStacks';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

VerticalStacksIcon.defaultProps = {
  size: 'small'
};

function VolumeIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M15.32 7.45h-2v1.06h2V8a4.93 4.93 0 000-.55zM12.91 11l1.56.37a6.28 6.28 0 00.45-1L13.16 10zm2-5.43a6.28 6.28 0 00-.45-1l-1.55.34.25 1zm-4.29-3.06L1.9 6.3v-.69H.65v4.78H1.9v-.71l8.72 3.79v1h1.25V1.5h-1.25zM1.9 8.32v-.65l8.72-3.8v8.24z\"></path>" } };
  var name = 'Volume';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

VolumeIcon.defaultProps = {
  size: 'small'
};

function WalletIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M14.25 1.5H1.75A1.25 1.25 0 00.5 2.75v1.11a1.85 1.85 0 011.25-.48v-.63h12.5v.63a1.85 1.85 0 011.25.48V2.75a1.25 1.25 0 00-1.25-1.25zm0 2.5H1.75A1.25 1.25 0 00.5 5.25v1.11a1.85 1.85 0 011.25-.48v-.63h12.5v.63a1.85 1.85 0 011.25.48V5.25A1.25 1.25 0 0014.25 4zm0 2.5H10.5A2.43 2.43 0 018 8.84 2.43 2.43 0 015.5 6.5H1.75A1.25 1.25 0 00.5 7.75v5.5a1.25 1.25 0 001.25 1.25h12.5a1.25 1.25 0 001.25-1.25v-5.5a1.25 1.25 0 00-1.25-1.25zm0 6.75H1.75v-5.5h2.73A3.76 3.76 0 008 10.09a3.75 3.75 0 003.52-2.34h2.73z\"></path>" } };
  var name = 'Wallet';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

WalletIcon.defaultProps = {
  size: 'small'
};

function WhatsappIcon(props) {
  var svgDataByHeight = { "16": { "width": 16, "path": "<path d=\"M11.42 9.49c-.19-.09-1.1-.54-1.27-.61s-.29-.09-.42.1-.48.6-.59.73-.21.14-.4 0a5.13 5.13 0 01-1.49-.92 5.25 5.25 0 01-1-1.29c-.11-.18 0-.28.08-.38s.18-.21.28-.32a1.39 1.39 0 00.18-.31.38.38 0 000-.33c0-.09-.42-1-.58-1.37s-.3-.32-.41-.32h-.4a.72.72 0 00-.5.23 2.1 2.1 0 00-.65 1.55A3.59 3.59 0 005 8.2 8.32 8.32 0 008.19 11c.44.19.78.3 1.05.39a2.53 2.53 0 001.17.07 1.93 1.93 0 001.26-.88 1.67 1.67 0 00.11-.88c-.05-.07-.17-.12-.36-.21z\"></path><path d=\"M13.29 2.68A7.36 7.36 0 008 .5a7.44 7.44 0 00-6.41 11.15l-1 3.85 3.94-1a7.4 7.4 0 003.55.9H8a7.44 7.44 0 005.29-12.72zM8 14.12a6.12 6.12 0 01-3.15-.87l-.22-.13-2.34.61.62-2.28-.14-.23a6.18 6.18 0 019.6-7.65 6.12 6.12 0 011.81 4.37A6.19 6.19 0 018 14.12z\"></path>" } };
  var name = 'Whatsapp';
  return React.createElement('svg', getSvgProps(_extends({}, props, { svgDataByHeight: svgDataByHeight, name: name })));
}

WhatsappIcon.defaultProps = {
  size: 'small'
};

export { AccordionIcon, AlignCenterIcon, AlignLeftIcon, AlignRightIcon, AppsIcon, ArchiveIcon, ArrowLeftIcon, ArrowRightIcon, ArrowsHorizontalIcon, ArrowsVerticalIcon, BackspaceIcon, BarcodeIcon, BoldIcon, BoxPackedIcon, BoxUnpackedIcon, BriefcaseIcon, BrowserIcon, BrowserSearchIcon, CalendarIcon, CalendarDaysIcon, CameraIcon, CashIcon, ChatDotsIcon, CheckIcon, CheckCircleIcon, ChevronDownIcon, ChevronLeftIcon, ChevronRightIcon, ChevronUpIcon, ChristIcon, ClockIcon, CloseIcon, CodeIcon, CogIcon, ColorPaletteIcon, CopyIcon, CreditCardIcon, DesktopIcon, DiscountCircleIcon, DisketteIcon, DownloadIcon, DragIcon, DragDotsIcon, DrinkIcon, DropIcon, DrumsIcon, DuplicateIcon, EcosystemIcon, EditIcon, EllipsisIcon, ExclamationCircleIcon, ExclamationTriangleIcon, ExternalLinkIcon, EyeIcon, EyeOffIcon, FileIcon, FileAltIcon, FingerprintIcon, FireIcon, FlagIcon, FontIcon, ForbiddenIcon, GiftBoxIcon, GiftCardIcon, GlassesIcon, GlobeIcon, GuitarIcon, HeartIcon, HistoryIcon, HomeIcon, InfiniteIcon, InfoCircleIcon, InvoiceIcon, ItalicIcon, LifeRingIcon, LightbulbIcon, LinkIcon, LinkOffIcon, ListIcon, LocationIcon, LockIcon, LockOpenIcon, LogOutIcon, MailIcon, MarketingIcon, MateIcon, MenuIcon, MobileIcon, MoneyIcon, MoonIcon, NotificationIcon, ObeliskIcon, OrderedListIcon, PencilIcon, PesoIcon, PictureIcon, PixIcon, PlanetIcon, PlusCircleIcon, PrinterIcon, PyramidIcon, QrCodeIcon, QuestionCircleIcon, RealIcon, RedoIcon, RemoveFormatIcon, RocketIcon, ScooterIcon, SearchIcon, ShareIcon, ShoppingCartIcon, ShotIcon, SizeHeightIcon, SizeWidthIcon, SlidersIcon, StarIcon, StatsIcon, StickyNoteIcon, StopIcon, StoreIcon, SunIcon, TagIcon, TelephoneIcon, TextSizeIcon, TiendanubeIcon, ToolsIcon, TransferPesoIcon, TransferRealIcon, TrashIcon, TruckIcon, UndoIcon, UniversityIcon, UploadIcon, UserIcon, UserCircleIcon, UserGroupIcon, VerticalStacksIcon, VolumeIcon, WalletIcon, WhatsappIcon };
